<template>
  <div class="media-player" ref="mediaPlayer">
    <Header
      v-if="!isModalMode"
      :header-icon="headerIcon"
      :is-from-mexico="booleanIsFromMexico"
      @click-open-modes="onClickOpenModes"
      @click-options="onClickModalLauncher"
    />
    <VideoPlayer
      v-show="!showImage"
      ref="videoPlayer"
      :player-queue="playerQueue"
      is-v2
      is-gs
      :container-width="mediaPlayerWidth"
      :game-id-selected="gameIdSelected"
      :is-first-row="isFirstRow"
      :plays-type-selected="selectedType"
      :is-auto-play="isAutoPlay"
      :is-modal-mode="isModalMode"
      :are-types-hidden="isSummaryData || isMyPlaylistsActive"
      :is-play-seeker-mode="booleanIsPlaySeekerMode"
      :play-sync="objectPlaySync"
      @play-iteration="onPlayIteration"
      @playing="onPlaying"
      @play-changed="onPlayChanged"
      @max-inactivity-reached="onMaxInactivityReached"
      @playlist-ended="onPlaylistEnded"
      @change-type="onTypeChanged"
      @play="booleanIsVideoPlayerPlaying = true"
      @pause="booleanIsVideoPlayerPlaying = false"
    />
    <div class="media-player__image" v-show="showImage">
      <div class="media-player__image__text"><span>Por Reproducir:</span> {{ seasonName }}</div>
    </div>
    <ControlsModal
      v-if="isModalMode"
      :play-info="playInfo"
      :title="this.stringModeTitle"
      :is-video-player-playing="booleanIsVideoPlayerPlaying"
      :player-speed="numberPlayerSpeed"
      :is-from-mexico="booleanIsFromMexico"
      @click-next-back="onClickNextBack"
      @click-option="onClickOption"
      @click-time-button="onClickTimeButton"
    />
    <Controls
      v-else
      :play-info="playInfo"
      :title="this.stringModeTitle"
      :is-video-player-playing="booleanIsVideoPlayerPlaying"
      :player-speed="numberPlayerSpeed"
      :is-from-mexico="booleanIsFromMexico"
      @click-next-back="onClickNextBack"
      @click-option="onClickOption"
      @click-time-button="onClickTimeButton"
    />
    <!--    <div class="media-player__play-info" :style="playInfoStyle">
      <div v-if="summaryData || isMyPlaylistsActive" class="media-player__play-info__entertainment">
        <div v-if="playInfo.teamLogo" class="team-logo">
          <img :src="playInfo.teamLogo" alt="" />
        </div>
        <div class="player">{{ playInfo.mainCategoryName }} - {{ playInfo.playerShortName || '' }}</div>
        <div class="vs">VS</div>
        <div v-if="playInfo.rivalLogo" class="team-logo">
          <img :src="playInfo.rivalLogo" alt="" />
        </div>
        <div>{{ playInfo.matchDayAbbreviation || '' }}</div>
      </div>
      <PlayInfo
        v-else
        :games-by-round="gamesByRound"
        :teams="teams"
        :play-info="playInfo"
        :info-type="selectedType"
        :container-width="mediaPlayerWidth"
        :is-retro="isRetroMode"
        :is-retro-mode-requested="isRetroRequested"
        :is-first-row="isFirstRow"
        :is-modal-mode="isModalMode"
        @player-select="onPlayerSelected"
        @team-select="onTeamSelected"
        @game-id-select="onGameIdSelected"
      />
    </div>
    <div v-if="false" class="media-player__mode">
      <div class="media-player__mode__options">
        <div class="media-player__mode__options__background" :class="{ retro: isRetroMode }" />
        <div
          v-for="mode in playerModes"
          :key="mode.id"
          :class="{ active: playerModeSelected === mode.id }"
          @click="onPlayerModeClicked(mode.id)"
        >
          {{ mode.name }}
        </div>
      </div>
    </div>
    <div v-if="false" class="media-player__categories">
      <div
        class="media-player__categories__goals"
        :class="{ 'button&#45;&#45;active': playsType === playsTypeOptions[0] }"
        @click="onPlaysTypeClicked(playsTypeOptions[0])"
      >
        <div>
          Goles
        </div>
      </div>
      <div
        class="media-player__categories__best-plays"
        :class="{ 'button&#45;&#45;active': playsType === playsTypeOptions[1] }"
        @click="onPlaysTypeClicked(playsTypeOptions[1])"
      >
        <div>
          Jugadas Relevantes
        </div>
      </div>
    </div>
    <div v-if="false" class="mediaplayer-player"></div>-->
    <MediaPlayerModesModal
      :is-modal-open="booleanIsModesModalOpen"
      :games-by-match-day="gamesByRound"
      @click-my-playlists="onClickMyPlaylists"
      @click-apply-filters="onClickApplyFilters"
      @click-full-game="onClickFullGame"
      @click-surprise-me="onClickSurpriseMe"
      @click-mode="onClickMode"
      @close="onModesModalClose"
    />
    <MediaPlayerSpeedModal
      :is-modal-open="booleanIsSpeedModalVisible"
      :current-speed="numberPlayerSpeed"
      @close="onModalSpeedClose"
      @click-speed="onClickSpeed"
    />
    <Confirm
      question="Hemos detectado un período largo de inactividad. ¿Sigues ahí?"
      :showModalConfirm="showModalConfirm"
      @onConfirm="confirmModalConfirm"
      @onCancel="closeModalConfirm"
      :textConfirm="'Continuar viendo'"
      :textCancel="'Salir'"
    />
    <MediaPlayerLaunchOptions
      :is-visible.sync="booleanIsOptionsMenuVisible"
      :top="numberOptionsMenuTop"
      :left="numberOptionsMenuLeft"
      @click-analyst="onClickAnalyst"
      @click-fullscreen="onClickFullscreen"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { findFieldArea } from '@/data/generators/statisticsFieldsData';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { regularLeague, cup, cupLegacy, cupLegacyAbb } from '@/utils/play-off-abbreviations';
import { getPlayContentFields } from '@/data/media-player-play-indexes';
import { getPlayContentIndex } from '@/data/media-player-play-seeker-indexes';
import EventBus from '@/utils/event-bus';

const playContentIndex = getPlayContentFields();
const playSeekerContentIndexes = getPlayContentIndex();
let playsPerGame = null;
const playsTypeOptions = ['goals', 'bestPlays'];
const allCategoriesNamesAndWeighing = {
  1: { name: 'Oportunidad de Gol', weighing: 3 },
  2: { name: 'Gol', weighing: 1 },
  3: { name: 'Autogol', weighing: 2 },
  4: { name: 'Tarjeta Amarilla', weighing: 5 },
  5: { name: 'Tarjeta Roja', weighing: 4 },
  6: { name: 'Penal Recibido', weighing: 6 },
  7: { name: 'Atajada', weighing: 8 },
  8: { name: 'Asistencia', weighing: 9 },
  9: { name: 'Participación en Gol', weighing: 14 },
  10: { name: 'Sobresaliente', weighing: 20 },
  11: { name: 'Centro Rematado', weighing: 11 },
  12: { name: 'Corner Rematado', weighing: 12 },
  13: { name: 'Tiro Libre Rematado', weighing: 13 },
  14: { name: '1vs1 Exitoso Ofensivo', weighing: 16 },
  15: { name: '1vs1 Exitoso Defensivo', weighing: 18 },
  16: { name: 'Pase Filtrado', weighing: 15 },
  17: { name: 'Balón ganado en Área Propia', weighing: 19 },
  18: { name: 'Balón Recuperado', weighing: 17 },
  19: { name: 'Gol Recibido', weighing: 7 },
  20: { name: 'Pases acertados', weighing: 100 },
  21: { name: 'Balones recuperados en disputa', weighing: 100 },
  22: { name: 'Asistencias', weighing: 100 },
  23: { name: 'Participaciones en gol', weighing: 100 },
  24: { name: 'Tiros a gol', weighing: 100 },
  25: { name: 'Tiros a gol que llegaron a la portería', weighing: 100 },
  26: { name: 'Cabeceos en área rival', weighing: 100 },
  27: { name: 'Cabeceos en área propia', weighing: 100 },
  28: { name: 'Centros', weighing: 100 },
  29: { name: 'Centros acertados', weighing: 100 },
  30: { name: '1vs1 exitosos ofensivo', weighing: 100 },
  31: { name: '1vs1 exitosos ofensivo que terminaron en gol', weighing: 100 },
  32: { name: '1vs1 defensivos exitoso', weighing: 100 },
  33: { name: 'Rechaces', weighing: 100 },
  34: { name: 'Balones ganados en área rival', weighing: 100 },
  35: { name: 'Balones ganados en área propia', weighing: 100 },
  36: { name: 'Faltas cometidas', weighing: 100 },
  37: { name: 'Faltas recibidas', weighing: 100 },
  38: { name: 'Tarjetas amarillas', weighing: 100 },
  39: { name: 'Tarjetas rojas', weighing: 100 },
  40: { name: 'Atajadas', weighing: 100 },
  41: { name: 'Tiros de Esquina', weighing: 100, bluer: true },
  42: { name: 'Balones recuperados en cancha rival', weighing: 100 },
  43: { name: 'Origen de gol', weighing: 10 },
};
const goalCategories = {
  player: {
    ['12-55']: allCategoriesNamesAndWeighing['2'],
  },
  gamesAndTeams: {
    ['12-55']: allCategoriesNamesAndWeighing['2'],
    ['54_r-35_r']: allCategoriesNamesAndWeighing['3'],
  },
};
const bestPlaysCategories = {
  games: {
    ['607-608']: allCategoriesNamesAndWeighing['1'],
    ['12-55']: allCategoriesNamesAndWeighing['2'],
    ['54-35']: allCategoriesNamesAndWeighing['3'],
    ['14-52']: allCategoriesNamesAndWeighing['4'],
    ['15-53']: allCategoriesNamesAndWeighing['5'],
    ['466-477']: allCategoriesNamesAndWeighing['6'],
  },
  team: {
    ['607-608']: allCategoriesNamesAndWeighing['1'],
    ['12-55']: allCategoriesNamesAndWeighing['2'],
    ['54-35']: allCategoriesNamesAndWeighing['3'],
    ['14-52']: allCategoriesNamesAndWeighing['4'],
    ['15-53']: allCategoriesNamesAndWeighing['5'],
    ['466-477']: allCategoriesNamesAndWeighing['6'],
    ['40-257']: allCategoriesNamesAndWeighing['19'],
    ['39']: allCategoriesNamesAndWeighing['7'],
  },
  player: {
    regular: {
      ['12']: allCategoriesNamesAndWeighing['2'],
      ['35']: allCategoriesNamesAndWeighing['3'],
      ['10']: allCategoriesNamesAndWeighing['8'],
      ['27']: allCategoriesNamesAndWeighing['9'],
      ['607']: allCategoriesNamesAndWeighing['1'],
      ['61']: allCategoriesNamesAndWeighing['43'],
      ['519']: allCategoriesNamesAndWeighing['10'],
      ['98-101-109-112']: allCategoriesNamesAndWeighing['11'],
      ['121-122-127-128-135-136-141-142']: allCategoriesNamesAndWeighing['12'],
      ['161-170-179']: allCategoriesNamesAndWeighing['13'],
      ['702']: allCategoriesNamesAndWeighing['14'],
      ['730']: allCategoriesNamesAndWeighing['15'],
      ['466']: allCategoriesNamesAndWeighing['6'],
      ['217']: allCategoriesNamesAndWeighing['16'],
      ['211-232-235-239-242-282-284-289-291-296']: allCategoriesNamesAndWeighing['17'],
      ['485-486-487-488']: allCategoriesNamesAndWeighing['18'],
      ['14']: allCategoriesNamesAndWeighing['4'],
      ['15']: allCategoriesNamesAndWeighing['5'],
      ['257']: allCategoriesNamesAndWeighing['19'],
    },
    goalkeeper: {
      ['55']: allCategoriesNamesAndWeighing['2'],
      ['324']: allCategoriesNamesAndWeighing['8'],
      ['323']: allCategoriesNamesAndWeighing['9'],
      ['608']: allCategoriesNamesAndWeighing['1'],
      ['39']: allCategoriesNamesAndWeighing['7'],
      ['774']: allCategoriesNamesAndWeighing['14'],
      ['802']: allCategoriesNamesAndWeighing['15'],
      ['52']: allCategoriesNamesAndWeighing['4'],
      ['53']: allCategoriesNamesAndWeighing['5'],
      ['40']: allCategoriesNamesAndWeighing['19'],
      ['54']: allCategoriesNamesAndWeighing['3'],
    },
  },
};
const extraCategories = {
  ['2-20']: allCategoriesNamesAndWeighing['20'],
  ['483']: allCategoriesNamesAndWeighing['21'],
  ['10']: allCategoriesNamesAndWeighing['22'],
  ['27']: allCategoriesNamesAndWeighing['23'],
  ['510']: allCategoriesNamesAndWeighing['24'],
  ['537-540-544-547']: allCategoriesNamesAndWeighing['25'],
  ['328']: allCategoriesNamesAndWeighing['26'],
  ['231-280-238-287-406-294']: allCategoriesNamesAndWeighing['27'],
  ['13-25']: allCategoriesNamesAndWeighing['28'],
  ['98-101-104-105-109-112-115-116']: allCategoriesNamesAndWeighing['29'],
  ['4']: allCategoriesNamesAndWeighing['30'],
  ['88']: allCategoriesNamesAndWeighing['31'],
  ['5']: allCategoriesNamesAndWeighing['32'],
  ['34']: allCategoriesNamesAndWeighing['33'],
  ['11']: allCategoriesNamesAndWeighing['34'],
  ['23']: allCategoriesNamesAndWeighing['35'],
  ['17']: allCategoriesNamesAndWeighing['36'],
  ['18']: allCategoriesNamesAndWeighing['37'],
  ['14']: allCategoriesNamesAndWeighing['38'],
  ['15']: allCategoriesNamesAndWeighing['39'],
  ['39']: allCategoriesNamesAndWeighing['40'],
  ['31-32']: allCategoriesNamesAndWeighing['41'],
  ['225-224']: allCategoriesNamesAndWeighing['42'],
};
const playSeekerClientId = 1;

import soccerChalkboardTeamOffensive from '@/data/team/offensiveChalkboardCategories';
import soccerChalkboardTeamDefensive from '@/data/team/defensiveChalkboardCategories';
import { allCategories as soccerChalkboardPlayerOffensive } from '@/data/player/offensiveChalkboardCategories';
import { allCategories as soccerChalkboardPlayerDefensive } from '@/data/player/defensiveChalkboardCategories';
import { allCategories as teamTableData } from '@/utils/dataTablesStructures/team';
import { allCategories as playerTableData } from '@/utils/dataTablesStructures/normalPlayer';
import { allCategories as goalkeeperTableData } from '@/utils/dataTablesStructures/goalkeeperPlayer';
import { allCategories as featuredPlayers } from '@/data/team/featured-players-categories';
import {
  fieldSectorsFromSectionsIndex,
  rivalFieldSectionsFromSectionsIndex,
} from '@/data/meda-player/advanced-filter-soccer-field';
import { getCategoryFormat } from '@/utils/misc';
import { areTwoObjectEquals } from '@/utils/misc';
import myPlaylistMixin from '@/mixins/my-playlist-mixin';
import { saveAs } from 'file-saver';

export default {
  components: {
    Header: () => import('@/components/Sections/MediaPlayer-v3/header/MediaPlayerHeader'),
    VideoPlayer: () => import('@/components/Sections/MediaPlayer-v3/VideoPlayer'),
    Controls: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerControls'),
    ControlsModal: () => import('@/components/Sections/MediaPlayer-v3/modal-mode/MediaPlayerModalControls'),
    MediaPlayerModesModal: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerModesModal'),
    MediaPlayerSpeedModal: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerSpeedModal'),
    Confirm: () => import('@/components/Modals/ConfirmMediaPlayer'),
    MediaPlayerLaunchOptions: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerLaunchOptions.vue'),
    // PlayInfo: () => import('@/components/Sections/MediaPlayer-v2/PlayInfo'),
  },

  props: {
    gsData: {
      type: [Object, null],
      default: null,
    },
    isFirstRow: {
      type: Boolean,
      default: false,
    },
    custom: {
      type: [Object, null],
      default: null,
    },
    autoFillVideos: {
      type: Boolean,
      default: false,
    },
    isPlayerUser: {
      type: Boolean,
      default: false,
    },
    isGoalkeeper: {
      type: [Boolean, Number],
      default: false,
    },
    playerId: {
      type: Number,
      default: 0,
    },
    isModalMode: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [myPlaylistMixin],
  data() {
    return {
      booleanIsFirstIteration: true,
      numberCurrentSeasonId: 0,
      numberLastActionId: 0,
      numberPlayerSpeed: 1,
      numberOptionsMenuTop: 0,
      numberOptionsMenuLeft: 0,
      booleanIsVideoPlayerPlaying: false,
      booleanIsOptionsMenuVisible: false,
      booleanIsSpeedModalVisible: false,
      showModalConfirm: false,
      showConfirmPlaylist: true,
      showModal: false,
      seasonId: 0,
      plays: [],
      playerQueue: [],
      playsType: playsTypeOptions[0],
      playsTypeOptions: playsTypeOptions,
      playInfo: {},
      teamsMap: new Map(),
      gamesMap: new Map(),
      roundsMap: new Map(),
      mediaPlayerMode: 'games', // values can be 'games', 'team' or 'player'
      playerPosition: 0,
      playlistTournament: null,
      showImage: false,
      seasonName: '',
      playlistSeasonIndex: 0,
      playlistSeasonIndexAux: 0,
      playerModeSelected: 1,
      currentTournament: { seasons: [] },
      mediaPlayerResizeObserver: null,
      mediaPlayerWidth: 1024,
      selectedType: 1,
      roundsAndGamesWithPlaysMap: null,
      gameIdSelected: 0,
      seasonSearchingCount: 0,
      hasPlayerActivityInTournament: false,
      isAutoPlay: false,
      storeModule: this.isModalMode ? 'mediaModal' : 'mediaGeneral',
      isFirstTypeChange: true,
      rivalCategories: [],
      counterAux: 0,
      useIdsFromAdvancedFilter: false,
      maxGameId: 0,
      tournamentsForModalLauncher: new Map(),
      lastGameIdWatched: 0,
      isSomeListSelected: false,
      booleanIsModesModalOpen: false,
      arrayCategoriesIdsToFilter: null,
      arrayRivalCategoriesIdsToFilter: null,
      arrayCategoriesIdsRaw: null,
      booleanIsFilterApplied: false,
      stringModeTitle: 'Estas viendo: Goles de la jornada',
      objectMediaPlayerModeFilters: this.getEmptyMediaPlayerModeFilters(),
      // PlaySeeker -------------------------------------------------------
      playSeekerPlays: [],
      geoOptions: {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      },
      coords: null,
      concatPlays: false,
      currentPlayIndex: 0,
      firstInteractionToken: '',
      firstInteractionUrl: 'https://playseeker-api-fi.golstats.com',
      userBehaviorUrl: 'https://playseeker-api-ub.golstats.com',
      gamesUrl: 'https://qyyibs1w0d.execute-api.us-west-2.amazonaws.com/prod/calendar/gamesBySeason?',
      // gamesUrl: 'https://kkd48smit2.execute-api.us-west-2.amazonaws.com/qa/calendar/gamesBySeason?',
      booleanIsPlaySeekerMode: false,
      objectLastDataToFilter: null,
      objectPlaySeekerLastPlay: null,
      objectPlaySync: null,
    };
  },
  computed: {
    // todo: add tournamentsForMediaPlayer into modalInitialState
    ...mapState('loginGeneral', [
      'tournamentSelected',
      'seasonSelected',
      'tournamentsForMediaPlayer',
      'user',
      'booleanIsFromMexico',
    ]),
    ...mapState('filterGeneral', {
      tournamentsProfiles: 'tournamentsForMediaPlayer',
    }),
    ...mapState('mediaModal', ['currentPlaylistPlays', 'modalSectionSelected', 'isModalOpen']),
    ...mapState('mediaGeneral', [
      'allAvailableTournaments',
      'playersMapMyPlaylists',
      'teamsMapMyPlaylists',
      'gamesMapMyPlaylists',
      'maxGameIdMyPlaylists',
      'player',
      'mapMinutesPlayedCategoryNames',
      'playSeekerUserId',
      'playSeekerCurrentSessionId',
    ]),
    ...mapGetters('mediaGeneral', ['userPlaylistsSeasonIds']),
    ...mapGetters('loginGeneral',
      ['getTournaments', 'getSeasons', 'getTournamentSelected', 'getSeasonSelected', 'getIsGSUser']
    ),
    mediaPlayerType() {
      return ['team', 'player'].includes(this.$route.name) ? 'summary' : 'general';
    },
    extraCategories() {
      const extraCategories = [
        ...soccerChalkboardTeamOffensive,
        ...soccerChalkboardTeamDefensive,
        ...soccerChalkboardPlayerOffensive,
        ...soccerChalkboardPlayerDefensive,
        ...teamTableData,
        ...playerTableData,
        ...goalkeeperTableData,
        ...featuredPlayers,
      ];
      return extraCategories.reduce((accumulator, category) => {
        category.categories.forEach(categoryId => {
          accumulator.set(categoryId, {
            id: categoryId,
            name: this.$t(category.translationKey || category.singleName),
          });
        });
        return accumulator;
      }, new Map());
    },
    isMyPlaylistsActive() {
      return this.isModalMode && this.modalSectionSelected === 2 && this.isSomeListSelected;
    },
    modalInitialState() {
      return this.isModalMode ? this.$store.state.mediaModal.modalInitialState : {};
    },
    modalSectionSelected() {
      return this.isModalMode ? this.$store.state.mediaModal.modalSectionSelected : {};
    },
    playerType() {
      return this.isModalMode ? this.$store.state.mediaModal.playerType : 0;
    },
    advancedFilter() {
      return this.isModalMode ? this.$store.state.mediaModal.advancedFilter : {};
    },
    applyAdvancedFilterCounter() {
      return this.isModalMode ? this.$store.state.mediaModal.applyAdvancedFilterCounter : 0;
    },
    selectedSubcategoryIds() {
      return this.isModalMode ? this.$store.state.mediaModal.selectedSubcategoryIds : [];
    },
    getSeasonIdOnly() {
      return this.$store.getters[`${this.storeModule}/getSeasonIdOnly`];
    },
    getTeamId() {
      return this.$store.getters[`${this.storeModule}/getTeamId`];
    },
    getPlayerId() {
      return this.$store.getters[`${this.storeModule}/getPlayerId`];
    },
    seasonPlayers() {
      return this.$store.getters[`${this.storeModule}/seasonPlayers`];
    },
    selectedTournament() {
      return this.$store.getters[`${this.storeModule}/selectedTournament`];
    },
    isPlayerGoalkeeper() {
      return this.$store.getters[`${this.storeModule}/isPlayerGoalkeeper`];
    },
    hasPlayerPositionId() {
      return this.$store.getters[`${this.storeModule}/hasPlayerPositionId`];
    },
    playersByTeam() {
      return this.$store.getters[`${this.storeModule}/playersByTeam`];
    },
    tournaments() {
      return this.$store.state[`${this.storeModule}`].tournaments;
    },
    seasonID() {
      return this.$store.state[`${this.storeModule}`].seasonID;
    },
    playlistIndex() {
      return this.$store.state[`${this.storeModule}`].playlistIndex;
    },
    retroSeason() {
      return this.$store.state[`${this.storeModule}`].retroSeason;
    },
    objectMediaData() {
      return this.$store.state[`${this.storeModule}`].objectMediaData;
    },
    playsSaved() {
      return this.$store.getters['mediaGeneral/playsSaved'];
    },
    summaryData() {
      return this.storeModule === 'mediaGeneral' && ['player', 'team'].includes(this.$route.name)
        ? this.$store.state[`${this.storeModule}`].summaryData
        : null;
    },
    isSummaryData() {
      return !!this.summaryData;
    },
    profilesSeasonId() {
      return !this.isModalMode ? this.$store.getters[`filterGeneral/getSeasonId`] : 0;
    },
    currentCategories() {
      if (this.isModalMode) {
        // 1 is for goals and 2 for best plays
        if (this.modalSectionSelected === 1) {
          if (this.modalInitialState) {
            return this.modalInitialState.categoryIds && this.modalInitialState.categoryIds.length
              ? this.modalInitialState.categoryIds
              : this.getBestCategoriesIds();
            // return Object.keys(
            //   this.modalInitialState.goalkeeperIds || this.modalInitialState.playerIds
            //     ? goalCategories.player
            //     : goalCategories.gamesAndTeams,
            // ).reduce((accumulator, categoryId) => {
            //   categoryId.split('-').forEach(categoryIdString => {
            //     accumulator.push(categoryIdString);
            //   });
            //   return accumulator;
            // }, []);
          } else {
            return [];
          }
        } else {
          // todo: missing my playlist behavior
          return this.useIdsFromAdvancedFilter
            ? this.selectedSubcategoryIds
            : this.modalInitialState
            ? this.modalInitialState.categoryIds
            : [];
        }
      } else if (this.summaryData) {
        return Object.keys(
          this.summaryData.isTeam
            ? goalCategories.gamesAndTeams
            : this.summaryData.positionId === 1
            ? bestPlaysCategories.player.goalkeeper
            : bestPlaysCategories.player.regular,
        ).reduce((accumulator, categoryId) => {
          categoryId.split('-').forEach(categoryIdString => {
            accumulator.push(categoryIdString);
          });
          return accumulator;
        }, []);
      } else {
        return Object.keys(
          this.user && this.user.is_player && this.hasUserPlayerSelectedSeason
            ? this.user.is_goalkeeper
              ? bestPlaysCategories.player.goalkeeper
              : bestPlaysCategories.player.regular
            : goalCategories.gamesAndTeams,
        ).reduce((accumulator, categoryId) => {
          categoryId.split('-').forEach(categoryIdString => {
            accumulator.push(categoryIdString);
          });
          return accumulator;
        }, []);
      }
    },
    allCategories() {
      const allCategories = new Map();
      const goalsAndExtraCategories = {
        ...goalCategories.gamesAndTeams,
        ...extraCategories,
      };
      Object.entries(goalsAndExtraCategories).forEach(([key, value]) => {
        key.split('-').forEach(categoryId => {
          allCategories.set(categoryId.includes('_r') ? categoryId : Number(categoryId), value);
        });
      });
      this.setBestCategoriesNames(allCategories);
      return allCategories;
    },
    queryCategories() {
      let queryCategories = '';
      const rivalCategories = [];
      // const categoriesAux = this.modalSectionSelected === 1 ? this.advancedFilter.categoryIds : this.currentCategories
      this.currentCategories.forEach((categoryId, index) => {
        let categoryIdAux = typeof categoryId === 'string' ? categoryId : categoryId.toString();
        let isRivalCategory = false;
        if (categoryIdAux.includes('_')) {
          isRivalCategory = true;
          categoryIdAux = Number(categoryIdAux.split('_')[0]);
          rivalCategories.push(categoryIdAux);
        }
        // eslint-disable-next-line no-param-reassign
        queryCategories += `${index > 0 ? '&' : ''}${isRivalCategory ? 'r' : ''}categories=${categoryIdAux}`;
      });
      this.setRivalCategories(rivalCategories);
      return queryCategories;
    },
    gamesByRound() {
      const gamesByRound = {};
      if (this.roundsAndGamesWithPlaysMap) {
        for (const [round, games] of this.roundsAndGamesWithPlaysMap) {
          const [name, abbreviation] = round.split(',');
          const gamesArr = Array.from(games.values());
          gamesArr.sort((a, b) => b.dateTimeMillis - a.dateTimeMillis);
          gamesByRound[abbreviation] = {
            name,
            games: gamesArr,
          };
        }
      }
      return gamesByRound;
    },
    teams() {
      if (this.teamsMap) {
        return Array.from(this.teamsMap.values());
      }
      return [];
    },
    isGoalsActive() {
      return this.playsType === playsTypeOptions[0];
    },
    headerResponsiveClass() {
      const responsiveClass = [];
      if (this.mediaPlayerWidth < 354) {
        responsiveClass.push('header--width-354');
      } else if (this.mediaPlayerWidth < 440) {
        responsiveClass.push('header--width-400');
      } else if (this.mediaPlayerWidth < 541) {
        responsiveClass.push('header--width-540');
      } else if (this.mediaPlayerWidth < 626) {
        responsiveClass.push('header--width-626');
      } else if (this.isFirstRow && this.mediaPlayerWidth < 610) {
        responsiveClass.push('header--first-row');
      }
      return responsiveClass;
    },
    playInfoStyle() {
      if (!this.gsData && this.mediaPlayerWidth < 871) {
        return { padding: '0 0.5em' };
      } else if (this.isFirstRow) {
        return { 'margin-top': '0.3em' };
      }
      return {};
    },
    headerIcon() {
      if (this.$route.query.logo) {
        return this.$route.query.logo;
      } else {
        if (this.custom != null) {
          if (Object.keys(this.custom).length) {
            return this.custom.logo;
          } else {
            return 'https://golstatsimages.blob.core.windows.net/content/shieldLogoPc.png';
          }
        } else {
          return 'https://golstatsimages.blob.core.windows.net/content/shieldLogoPc.png';
        }
      }
    },
    isUserTournament() {
      return this.gsData && this.gsData.tournamentId === this.currentTournament._id;
    },
    hasUserPlayerSelectedSeason() {
      if (this.user.is_player) {
        return this.user.related_seasons.includes(this.numberCurrentSeasonId || this.seasonSelected);
      }
      return false;
    },
    hasUserTeamSelectedTournament() {
      if (!this.user.is_player && this.user.team) {
        return this.user.related_seasons.includes(this.numberCurrentSeasonId || this.seasonSelected);
      }
      return false;
    },
  },
  watch: {
    isModalOpen(newValue) {
      if (!newValue) {
        this.applyObjectMediaData();
      }
    },
    seasonSelected() {
      this.setInitialTitle();
    },
    tournamentSelected() {
      this.setInitialTitle();
    },
    selectedTournament: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.playlistTournament = newValue;
          this.playlistSeasonIndex = 0;
        }
      },
    },
    seasonID: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.playlistSeasonIndexAux = newValue.index;
        }
      },
    },
    playsType(newValue) {
      if (!this.isModalMode) {
        this.setPlaysType({
          mediaPlayerType: this.mediaPlayerType,
          playsType: newValue,
        });
      }
      this.fetchInfo(true, this.playlistTournament);
    },
    modalSectionSelected(newValue) {
      if (newValue !== 1) {
        this.isSomeListSelected = false;
      }
      if ([0, 1].includes(newValue)) {
        if (this.playsType !== playsTypeOptions[newValue]) {
          this.playsType = playsTypeOptions[newValue];
        } else {
          this.fetchInfo(true, this.playlistTournament);
        }
      }
      if (this.modalInitialState && this.modalInitialState.mainSectionType - 1 === this.modalSectionSelected) {
        this.checkSeason();
      }
    },
    selectedSubcategoryIds(newValue) {
      if (newValue && newValue.length) {
        this.applyAdvancedFilter();
      }
    },
    seasonPlayers(newValue) {
      if (this.getPlayerId && !this.hasPlayerPositionId) {
        const player = newValue.get(this.getPlayerId);
        if (player) {
          this.$store.commit(`${this.storeModule}/setPlayer`, player);
        }
      }
    },
    profilesSeasonId: {
      handler(newValue) {
        if (newValue && this.$route.name !== 'landing') {
          this.setUpData(newValue);
        }
      },
    },
    summaryData: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        if (
          ['team', 'player'].includes(this.$route.name) &&
          newValue &&
          (!areTwoObjectEquals({ ...newValue }, { ...oldValue }) || !this.playerQueue.length) &&
          !this.isModalMode
        ) {
          if (newValue.isTeam) {
            this.selectedType = 3;
            this.mediaPlayerMode = 'team';
            this.$store.commit(`${this.storeModule}/setPlayer`, null);
            this.$store.commit(`${this.storeModule}/setTeam`, newValue.subjectId);
          } else {
            this.selectedType = 2;
            this.playsType = this.playsTypeOptions[1];
            this.mediaPlayerMode = 'player';
            this.$store.commit(`${this.storeModule}/setPlayer`, {
              id: newValue.subjectId,
              positionId: newValue.positionId,
            });
            this.$store.commit(`${this.storeModule}/setTeam`, newValue.teamId);
          }
          if (newValue.seasonId) {
            this.setUpData(newValue.seasonId, true);
          }
        }
      },
    },
    tournamentsForMediaPlayer(newValue) {
      if (
        this.seasonSelected &&
        (this.$route.name === 'landing' || this.$route.name === 'landingV2') &&
        newValue.size > 0 &&
        !this.isModalMode
      ) {
        this.setUpData(this.seasonSelected);
      }
    },
    currentPlaylistPlays(newValue) {
      if (this.isModalMode && this.modalSectionSelected === 2) {
        this.setPlaylistPlays(newValue);
      }
    },
    userPlaylistsSeasonIds(newValue) {
      this.fillMyPlaylistsData(Array.from(newValue.values()));
    },
    seasonId: {
      immediate: true,
      handler(newValue) {
        if (!this.isModalMode) {
          this.setSeasonId({
            mediaPlayerType: this.mediaPlayerType,
            seasonId: newValue,
          });
        }
      },
    },
    currentCategories: {
      immediate: true,
      handler(newValue) {
        if (!this.isModalMode) {
          this.setCurrentCategories({
            mediaPlayerType: this.mediaPlayerType,
            currentCategories: newValue,
          });
        }
      },
    },
    selectedType: {
      immediate: true,
      handler(newValue) {
        if (!this.isModalMode) {
          this.setSelectedType({
            mediaPlayerType: this.mediaPlayerType,
            selectedType: newValue,
          });
        }
      },
    },
    getTeamId: {
      immediate: true,
      handler(newValue) {
        if (!this.isModalMode) {
          this.setTeamId({
            mediaPlayerType: this.mediaPlayerType,
            teamId: newValue,
          });
        }
      },
    },
    player: {
      immediate: true,
      handler(newValue) {
        if (!this.isModalMode) {
          this.setModalPlayer({
            mediaPlayerType: this.mediaPlayerType,
            player: newValue,
          });
        }
      },
    },
  },
  methods: {
    ...mapMutations(['setIsSectionLoading']),
    ...mapMutations('mediaModal', [
      'setPlaylistGameId',
      'setPlayerType',
      'setModalInitialState',
      'setIsModalOpen',
      'setIsModalCreatePlayListOpen',
    ]),
    ...mapMutations('mediaGeneral', [
      'setAllAvailableTournaments',
      'setPlayersMapMyPlaylists',
      'setTeamsMapMyPlaylists',
      'setGamesMapMyPlaylists',
      'setMaxGameIdMyPlaylists',
      'setSeasonId',
      'setPlaysType',
      'setCurrentCategories',
      'setSelectedType',
      'setTournamentsForModalLauncher',
      'setTeamId',
      'setModalPlayer',
      'setPlaysToSaveAsFavorites',
      'setPlaySeekerUserId',
      'setPlaySeekerCurrentSessionId',
    ]),
    ...mapActions('loginGeneral', [
      'storeTournamentSelected',
      'storeSeasonSelected',
      'storeTournamentNameSelected',
      'storeSeasonNameSelected',
    ]),
    applyObjectMediaData() {
      if (
        !this.objectMediaData ||
        this.objectMediaData.booleanAvoidApply ||
        (['player', 'team'].includes(this.$route.name) && !this.isModalMode)
      ) {
        return;
      }
      if (this.objectMediaData.numberMainSectionType) {
        this.$store.commit('mediaModal/setModalSectionSelected', this.objectMediaData.numberMainSectionType);
      }
      this.objectPlaySync = this.objectMediaData.objectPlaySync
        ? { ...this.objectMediaData.objectPlaySync, booleanIsApplied: false }
        : null;
      this.stringModeTitle = this.objectMediaData.stringModeTitle;
      this.playerQueue = [...this.objectMediaData.arrayPlayerQueue];
      this.$store.commit(`${this.storeModule}/setPlaylistIndex`, {
        mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
        playlistIndex: this.objectMediaData.numberPlaylistIndex,
      });
      if (this.isModalMode) {
        this.$store.commit('mediaModal/setCurrentPlayerQueue', this.playerQueue);
      }
      this.playlistSeasonIndex = this.objectMediaData.numberPlaylistSeasonIndex;
      this.booleanIsPlaySeekerMode = this.objectMediaData.booleanIsPlaySeekerMode;
      this.booleanIsFilterApplied = this.objectMediaData.booleanIsFilterApplied;
      if (this.objectMediaData.objectLastDataToFilter) {
        this.fillDataToFilterData(this.objectMediaData.objectLastDataToFilter);
      }
    },
    setPlaylistPlays(plays) {
      const formattedPlays = this.getFormattedPlays(plays, true);
      this.generatePlayerQueue(null, formattedPlays, true);
    },
    applyAdvancedFilter() {
      this.useIdsFromAdvancedFilter = true;
      this.fetchInfo(true, this.playlistTournament);
    },
    setRivalCategories(rivalCategories) {
      this.rivalCategories = rivalCategories;
    },
    setUpData(seasonId, skipPlayerValidation = false) {
      if (!this.booleanIsFromMexico && !this.getIsGSUser) {
        this.$emit('finish');
        return;
      }
      let isModalInitialStateEmpty = false;
      let tournaments = this.isModalMode
        ? this.modalInitialState.tournaments
        : this.summaryData
        ? this.tournamentsProfiles
        : this.tournamentsForMediaPlayer;
      if (!tournaments || tournaments.size === 0) {
        tournaments = this.tournamentsForMediaPlayer;
        isModalInitialStateEmpty = true;
      }
      if (!seasonId) {
        isModalInitialStateEmpty = true;
        // eslint-disable-next-line no-param-reassign
        seasonId = this.seasonSelected;
      }
      const seasonSelectedId = Number(seasonId);
      let selectedTournament = tournaments.get(seasonSelectedId);
      this.tournamentsForModalLauncher = tournaments;
      if (!this.isModalMode) {
        this.setTournamentsForModalLauncher({
          mediaPlayerType: this.mediaPlayerType,
          tournamentsForModalLauncher: tournaments,
        });
      }
      if (
        !selectedTournament &&
        this.isModalMode &&
        this.modalInitialState &&
        this.modalInitialState.tournamentsLastClashes
      ) {
        selectedTournament = this.modalInitialState.tournamentsLastClashes.get(seasonId);
      }
      this.playlistTournament = selectedTournament;
      if (selectedTournament) {
        if (this.summaryData) {
          this.stringModeTitle = this.summaryData.isTeam
            ? 'Estas viendo: Resumen equipo'
            : 'Estas viendo: Resumen jugador';
        }
        this.playlistSeasonIndex = selectedTournament.seasons.findIndex(season => season.id === seasonSelectedId);
        this.playlistSeasonIndexAux = this.playlistSeasonIndex;
        if (!skipPlayerValidation) {
          if (this.summaryData) {
            // todo: what happens if player has no activity
          } else {
            if (this.isPlayerUser /*&& !skipPlayerValidation*/) {
              this.hasPlayerActivityInTournament = !!this.getPlayerTournamentBySelectedSeason(
                seasonSelectedId,
                tournaments,
              );
              if (this.hasPlayerActivityInTournament) {
                const player = { id: Number(this.user.player) };
                if (this.isGoalkeeper) {
                  player.positionId = 1;
                }
                this.seasonSearchingCount = 0;
                this.$store.commit(`${this.storeModule}/setPlayer`, player);
                this.$store.commit(`${this.storeModule}/setTeam`, this.gsData.teamId);
                this.onPlayerSelected();
                return;
              }
              if (!this.hasPlayerActivityInTournament && this.selectedType !== 1 /* || skipPlayerValidation*/) {
                this.$store.commit(`${this.storeModule}/setPlayer`, null);
                this.$store.commit(`${this.storeModule}/setTeam`, null);
              }
            } else if (this.gsData && this.gsData.tournamentId === this.playlistTournament._id && this.gsData.teamId) {
              this.seasonSearchingCount = 0;
              this.$store.commit(`${this.storeModule}/setPlayer`, null);
              this.$store.commit(`${this.storeModule}/setTeam`, this.gsData.teamId);
              this.onTeamSelected();
              return;
            } else {
              this.seasonSearchingCount = 0;
              this.$store.commit(`${this.storeModule}/setPlayer`, null);
              this.$store.commit(`${this.storeModule}/setTeam`, null);
            }
          }
        }
        this.fillSeasons([selectedTournament], isModalInitialStateEmpty);
      }
    },
    setInitialTitle() {
      if (!this.summaryData && !this.booleanIsFilterApplied && this.hasUserPlayerSelectedSeason) {
        this.stringModeTitle = 'Estas viendo: Resumen de jugador';
      } else if (!this.summaryData && !this.booleanIsFilterApplied && this.hasUserTeamSelectedTournament) {
        this.stringModeTitle = 'Estas viendo: Resumen de equipo';
      } else {
        this.stringModeTitle = 'Estas viendo: Goles de la jornada';
      }
    },
    closeModalConfirm() {
      this.showModalConfirm = false;
    },
    onModalSpeedClose() {
      this.booleanIsSpeedModalVisible = false;
    },
    onClickSpeed(numberSpeed) {
      this.numberPlayerSpeed = numberSpeed;
      this.$refs.videoPlayer.setSpeedToAllPlayers(numberSpeed);
      this.booleanIsSpeedModalVisible = false;
    },
    confirmModalConfirm() {
      this.showModalConfirm = false;
      this.$refs.videoPlayer.playCurrentVideoPlayer();
    },
    openmodal() {
      this.$refs.videoPlayer.setAutoPlaysCount(0);
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    getBestCategoriesIds() {
      let keys = null;
      if (this.mediaPlayerMode === 'player') {
        if (this.isPlayerGoalkeeper) {
          keys = Object.keys(bestPlaysCategories.player.goalkeeper);
        } else {
          keys = Object.keys(bestPlaysCategories.player.regular);
        }
      } else {
        keys = Object.keys(bestPlaysCategories[this.mediaPlayerMode]);
      }
      return keys.reduce((accumulator, key) => {
        key.split('-').forEach(categoryIdString => {
          accumulator.push(categoryIdString);
        });
        return accumulator;
      }, []);
    },
    setBestCategoriesNames(namesMap) {
      let entries = [
        ...Object.entries(bestPlaysCategories.player.goalkeeper),
        ...Object.entries(bestPlaysCategories.player.regular),
        ...Object.entries(bestPlaysCategories[this.mediaPlayerMode]),
      ];
      // if (this.mediaPlayerMode === 'player') {
      //   if (this.isPlayerGoalkeeper) {
      //     entries = Object.entries(bestPlaysCategories.player.goalkeeper);
      //   } else {
      //     entries = Object.entries(bestPlaysCategories.player.regular);
      //   }
      // } else {
      //   entries = Object.entries(bestPlaysCategories[this.mediaPlayerMode]);
      // }
      entries.forEach(([key, value]) => {
        key.split('-').forEach(categoryIdString => {
          namesMap.set(Number(categoryIdString), value);
        });
      });
    },
    onPlaysTypeClicked(playsType) {
      this.playsType = playsType;
    },
    getPlayTime(gamePlay, timeProp) {
      let syncTime = '';
      let minutesToSubtract = 0;
      switch (gamePlay.matchLapse) {
        case 1:
          syncTime = gamePlay.syncStartFirstTime;
          break;
        case 2:
          syncTime = gamePlay.syncStartSecondTime;
          minutesToSubtract = 45;
          break;
        case 3:
          syncTime = gamePlay.syncStartFirstExtraTime;
          minutesToSubtract = 90;
          break;
        case 4:
          syncTime = gamePlay.syncStartSecondExtraTime;
          minutesToSubtract = 105;
          break;
        case 5:
          syncTime = gamePlay.syncStartPenals;
          minutesToSubtract = 120;
          break;
      }
      if (!syncTime || syncTime === '0') {
        syncTime = '00:00';
      }
      return this.getTimeToSeconds(syncTime) + (this.getTimeToSeconds(gamePlay[timeProp]) - minutesToSubtract * 60);
    },
    getTimeToSeconds(timeString) {
      const dotIndex = timeString.indexOf('.');
      const stringAux = dotIndex > -1 ? timeString.substring(0, timeString.indexOf('.')) : timeString;
      const [seconds, minutes, hours] = stringAux.split(':').reverse();

      return (hours ? Number(hours) * 60 * 60 : 0) + Number(minutes) * 60 + Number(seconds);
    },
    getFormattedPlays(plays, isMyPlaylists = false, objectSeasonSelected = null) {
      this.roundsAndGamesWithPlaysMap = new Map();
      playsPerGame = new Map();
      plays.forEach(play => {
        const playObject = play.reduce((accumulator, value, index) => {
          accumulator[playContentIndex[index]] = value;
          return accumulator;
        }, {});
        playObject.playRaw = play;
        let gameAux = null;
        let player = null;
        let teamsMap = null;
        let maxGameId = 0;
        if (isMyPlaylists) {
          teamsMap = this.teamsMapMyPlaylists;
          maxGameId = this.maxGameIdMyPlaylists;
          gameAux = this.gamesMapMyPlaylists.get(playObject.gameId);
          player = this.playersMapMyPlaylists.get(playObject.playerId);
          playObject.booleanIsFromMyPlaylists = true;
        } else {
          teamsMap = objectSeasonSelected ? objectSeasonSelected.mapTeams : this.teamsMap;
          maxGameId = objectSeasonSelected ? objectSeasonSelected.maxGameId : this.maxGameId;
          gameAux = objectSeasonSelected
            ? objectSeasonSelected.mapGames.get(playObject.gameId)
            : this.gamesMap.get(playObject.gameId);
          player = objectSeasonSelected
            ? objectSeasonSelected.mapPlayers.get(playObject.playerId)
            : this.seasonPlayers.get(playObject.playerId);
        }
        if (player && gameAux && playObject.gameId <= maxGameId) {
          const roundKey = `${gameAux.roundName},${gameAux.roundAbbreviation},${gameAux.seasonId}`;
          const roundAux = this.roundsAndGamesWithPlaysMap.get(roundKey);
          if (roundAux) {
            roundAux.set(gameAux.id, gameAux);
          } else {
            this.roundsAndGamesWithPlaysMap.set(roundKey, new Map().set(gameAux.id, gameAux));
          }
          playObject.game = gameAux;
          if (playObject.game.awayTeam.id === playObject.teamId) {
            playObject.teamName = playObject.game.awayTeam.name;
            playObject.rivalName = playObject.game.homeTeam.name;
          } else {
            playObject.teamName = playObject.game.homeTeam.name;
            playObject.rivalName = playObject.game.awayTeam.name;
          }
          playObject.playingAs = playObject.teamId === playObject.game.homeTeam.id ? 1 : 2;
          playObject.player = player;
          playObject.playerTeamLogo = teamsMap.get(playObject.player.teamId).logo;
          playObject.rivalTeamLogo = teamsMap.get(
            playObject.player.teamId === playObject.game.homeTeam.id
              ? playObject.game.awayTeam.id
              : playObject.game.homeTeam.id,
          ).logo;
          playObject.startSeconds = this.getPlayTime(playObject, 'startTime');
          playObject.endSeconds = this.getPlayTime(playObject, 'endTime');
          const gameDateTime = new Date(playObject.gameDate);
          const [hours, minutes] = playObject.gameHour.split(':');
          gameDateTime.setHours(hours);
          gameDateTime.setMinutes(minutes);
          playObject.dateTimeMillis = gameDateTime.valueOf();
          if (!playsPerGame.has(playObject.gameId)) {
            playsPerGame.set(playObject.gameId, {
              dateTimeMillis: gameDateTime.valueOf(),
              plays: [playObject],
            });
          } else {
            const playsInGame = playsPerGame.get(playObject.gameId);
            playsInGame.plays.push(playObject);
          }
        }
      });
      const playsPerGameArray = Array.from(playsPerGame.values());
      playsPerGameArray.sort((a, b) => {
        return b.dateTimeMillis - a.dateTimeMillis;
      });
      return playsPerGameArray.reduce((accumulator, playsInGame) => {
        playsInGame.plays.sort((a, b) => {
          return (
            Number(`${a.matchLapse}${a.startTime.replace(/:*\.*/g, '')}`) -
            Number(`${b.matchLapse}${b.startTime.replace(/:*\.*/g, '')}`)
          );
        });
        accumulator.push(...playsInGame.plays);
        return accumulator;
      }, []);
    },
    generatePlayerQueue(
      categoriesId,
      plays,
      isFromMyPlaylist = false,
      numberPlaylistIndex = -1,
      booleanIsFromApplyFilters,
    ) {
      if (!plays.length) {
        return;
      }
      const playsMap = new Map();
      const advancedFilterAux = this.modalInitialState ? this.modalInitialState.advancedFilter || {} : {};
      if (advancedFilterAux && advancedFilterAux.fieldSections) {
        advancedFilterAux.fieldSectors = advancedFilterAux.fieldSections.map(numberFieldSection => {
          return fieldSectorsFromSectionsIndex[`${numberFieldSection}`];
        });
      }
      // this.modalSectionSelected === 1 ? this.advancedFilter : this.modalInitialState.advancedFilter;
      let playAddedCounter = 0;
      let lastGameWatchedIdIndex = 0;
      this.playerQueue = plays.reduce((accumulator, play) => {
        // todo: add momen.mapGamesByTeamtOfPlay and endTime
        const playKey = `${play.gameId}-${play.playerId}-${play.startTime}`;
        let skip = false;
        if (this.isModalMode && !isFromMyPlaylist && !booleanIsFromApplyFilters) {
          if (this.modalInitialState.lastClashesGameId) {
            skip = play.gameId !== this.modalInitialState.lastClashesGameId;
          }
          const teamId = this.getTeamId || this.modalInitialState.teamId;
          if (teamId) {
            skip = play.game.homeTeam.id !== teamId && play.game.awayTeam.id !== teamId;
          }
          if (!skip && this.selectedType === 2) {
            skip = this.getPlayerId !== play.playerId;
          }
          if (!skip && advancedFilterAux) {
            if (advancedFilterAux.playingAs && advancedFilterAux.playingAs.length) {
              skip =
                advancedFilterAux.requiresRivalTransform && advancedFilterAux.playingAs.length === 1
                  ? play.teamId !== teamId
                    ? advancedFilterAux.playingAs.includes(play.playingAs)
                    : !advancedFilterAux.playingAs.includes(play.playingAs)
                  : !advancedFilterAux.playingAs.includes(play.playingAs);
            }
            if (!skip && advancedFilterAux.timeSections && advancedFilterAux.timeSections.length) {
              skip = !advancedFilterAux.timeSections.includes(play.section);
            }
            if (!skip && advancedFilterAux.coordinatePoint && advancedFilterAux.fieldSectors) {
              const playFieldArea =
                findFieldArea(
                  play[`x${advancedFilterAux.coordinatePoint}`],
                  play[`y${advancedFilterAux.coordinatePoint}`],
                ) + 1;
              skip = !advancedFilterAux.fieldSectors.includes(playFieldArea);
              // const fieldAreaString = `${playFieldArea}`;
              // const playFieldSectorAux = fieldSectorsFromSectionsIndex[fieldAreaString];
              // const playFieldSector = this.advancedFilter.requiresRivalTransform
              //   ? this.selectedSubcategoryIds.includes(`${play.categoryId}_r`)
              //     ? fieldSectorsFromSectionsIndex[`${rivalFieldSectionsFromSectionsIndex[fieldAreaString]}`]
              //     : playFieldSectorAux
              //   : playFieldSectorAux;
              // skip = !advancedFilterAux.fieldSectors.find(
              //   fieldSector => fieldSector.num === playFieldSector && fieldSector.status,
              // );
            }
          }
          if (!skip && teamId && this.modalInitialState.matchResult && this.modalInitialState.matchResult.length) {
            const playGameResult =
              // 3 = tie, 1 = selected team win, 2 = selected team lose
              play.game.gameResult === 3
                ? 3
                : (play.game.gameResult === 1 && teamId === play.game.homeTeam.id) ||
                  (play.game.gameResult === 2 && teamId === play.game.awayTeam.id)
                ? 1
                : 2;
            skip = !this.modalInitialState.matchResult.includes(playGameResult);
          }
        }
        const arrayCategoriesId = this.arrayCategoriesIdsToFilter || categoriesId;
        const arrayRivalCategoriesId = this.arrayRivalCategoriesIdsToFilter || this.rivalCategories;
        if (
          isFromMyPlaylist ||
          ((booleanIsFromApplyFilters || !skip) &&
            (arrayCategoriesId.includes(play.categoryId) ||
              (arrayRivalCategoriesId.includes(play.categoryId) &&
                (this.booleanIsFilterApplied || (this.getTeamId ? play.rivalTeamId === this.getTeamId : true)))) &&
            play.startSeconds !== play.endSeconds)
        ) {
          const playAux = playsMap.get(playKey);
          let categoryAux =
            this.modalInitialState &&
            this.modalInitialState.mainSectionType === this.modalSectionSelected + 1 &&
            this.modalInitialState.categorySingleName &&
            !this.modalInitialState.avoidCategorySingleName &&
            // auto goals ids
            ![35, 54].includes(play.categoryId)
              ? { name: this.modalInitialState.categorySingleName }
              : this.allCategories.get(play.categoryId) ||
                this.allCategories.get(`${play.categoryId}_r`) ||
                this.extraCategories.get(play.categoryId) ||
                this.extraCategories.get(`${play.categoryId}_r`);
          if (this.modalInitialState && this.modalInitialState.avoidCategorySingleName) {
            categoryAux = { name: this.modalInitialState.categorySingleName, weighing: 1 };
          } else if (this.isModalMode && play.categoryId === 33) {
            categoryAux = { name: 'Fuera de lugar', weighing: 1 };
          }
          let stringCategoryName = '';
          if (!categoryAux) {
            stringCategoryName = this.mapMinutesPlayedCategoryNames.get(play.categoryId);
            if (stringCategoryName) {
              categoryAux = { name: stringCategoryName, weighing: 1 };
            } else if (!categoryAux && advancedFilterAux) {
              categoryAux = {
                name: advancedFilterAux.playListTitle,
                weighing: 100,
              };
            }
          }
          if (!categoryAux) {
            categoryAux =
              this.allCategories.get(play.categoryId) ||
              this.allCategories.get(`${play.categoryId}_r`) ||
              this.extraCategories.get(play.categoryId) ||
              this.extraCategories.get(`${play.categoryId}_r`);
          }
          if (!lastGameWatchedIdIndex) {
            if (this.lastGameIdWatched === play.gameId) {
              lastGameWatchedIdIndex = playAddedCounter;
            }
            playAddedCounter++;
          }
          if (!playAux) {
            play.isSaved = this.playsSaved.has(play.playId);
            play.mainCategory = categoryAux;
            play.categoriesNames = new Set();
            play.categoriesNames.add(categoryAux.name);
            playsMap.set(playKey, play);
            accumulator.push(play);
          } else {
            if (categoryAux.weighing < playAux.mainCategory.weighing) {
              playAux.mainCategory = categoryAux;
            }
            playAux.categoriesNames.add(categoryAux.name);
          }
        }
        return accumulator;
      }, []);
      this.showImage = false;
      if (this.isModalMode) {
        if (isFromMyPlaylist) {
          this.$store.commit('mediaModal/setPlaylistIndex', {
            mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
            playlistIndex: 0,
          });
        } else {
          if (this.modalInitialState && this.modalInitialState.playData) {
            const playIndex = this.playerQueue.findIndex(play => {
              return play.playId === this.modalInitialState.playData.playId;
            });
            if (playIndex !== -1) {
              this.$store.commit('mediaModal/setPlaylistIndex', {
                mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
                playlistIndex: playIndex,
              });
            }
          }
          if (this.playerQueue.length) {
            if (booleanIsFromApplyFilters && this.objectMediaPlayerModeFilters.objectGameSelected) {
              const gameFirstPlayIndex = this.playerQueue.findIndex(
                play => this.objectMediaPlayerModeFilters.objectGameSelected.game_id === play.game.id,
              );
              if (gameFirstPlayIndex !== -1) {
                this.$store.commit('mediaModal/setPlaylistIndex', {
                  mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
                  playlistIndex: gameFirstPlayIndex,
                });
              }
            } else if (
              this.modalInitialState &&
              !this.modalInitialState.lastClashesGameId &&
              this.modalInitialState.gameIds &&
              this.selectedType === 1
            ) {
              const gameFirstPlayIndex = this.playerQueue.findIndex(play =>
                this.modalInitialState.gameIds.includes(play.game.id),
              );
              if (gameFirstPlayIndex !== -1) {
                this.$store.commit('mediaModal/setPlaylistIndex', {
                  mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
                  playlistIndex: gameFirstPlayIndex,
                });
              } else {
                this.playerQueue = [];
              }
            } else if (this.modalInitialState && this.modalInitialState.currentPlayIndex) {
              this.$store.commit('mediaModal/setPlaylistIndex', {
                mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
                playlistIndex: this.modalInitialState.currentPlayIndex,
              });
            } else {
              if (numberPlaylistIndex > -1) {
                this.$store.commit('mediaModal/setPlaylistIndex', {
                  mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
                  playlistIndex: numberPlaylistIndex,
                });
              }
            }
          }
        }
        this.$store.commit('mediaModal/setCurrentPlayerQueue', this.playerQueue);
      } else {
        if (booleanIsFromApplyFilters && this.objectMediaPlayerModeFilters.objectGameSelected) {
          const gameFirstPlayIndex = this.playerQueue.findIndex(
            play => this.objectMediaPlayerModeFilters.objectGameSelected.game_id === play.game.id,
          );
          if (gameFirstPlayIndex !== -1) {
            this.$store.commit('mediaGeneral/setPlaylistIndex', {
              mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
              playlistIndex: gameFirstPlayIndex,
            });
          }
        } else if (numberPlaylistIndex > -1) {
          this.$store.commit('mediaGeneral/setPlaylistIndex', {
            mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
            playlistIndex: numberPlaylistIndex,
          });
        } else if (this.selectedType === 1 && lastGameWatchedIdIndex) {
          this.$store.commit('mediaGeneral/setPlaylistIndex', {
            mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
            playlistIndex: lastGameWatchedIdIndex,
          });
        }
      }
      if (!this.playerQueue.length) {
        this.emptyListDecision();
      }
      if (this.booleanIsFirstIteration) {
        this.booleanIsFirstIteration = false;
        this.$emit('finish');
      }
    },
    emptyListDecision() {
      if (this.summaryData && this.summaryData.isTeam && this.playsType === this.playsTypeOptions[0]) {
        this.playsType = this.playsTypeOptions[1];
      } else if (!this.summaryData && !this.isModalMode) {
        this.onTypeChanged(1);
      }
    },
    getGeneralName(categoryName) {
      const categoryNameArray = categoryName.split(' ');
      return categoryNameArray
        .reduce((accumulator, word, index) => {
          if (index === 0) {
            if (word.includes('.')) {
              accumulator.push(word);
            } else {
              const wordAux = word.toLowerCase().split('');
              wordAux[0] = wordAux[0].toUpperCase();
              accumulator.push(wordAux.join(''));
            }
          } else {
            accumulator.push(word.toLowerCase());
          }
          return accumulator;
        }, [])
        .join(' ');
    },
    getSingleName(categoryName) {
      const categoryNameArray = categoryName.split(' ');
      return categoryNameArray
        .reduce((accumulator, word) => {
          let wordAux = word;
          if (word.endsWith('ciones')) {
            wordAux = word.replace('ciones', 'ción');
          } else if (word.endsWith('nales')) {
            wordAux = word.replace('nales', 'nal');
          } else if (word.endsWith('vocan')) {
            wordAux = word.replace('vocan', 'voca');
          } else if (word.endsWith('lones')) {
            wordAux = word.replace('lones', 'lón');
          } else if (word.endsWith('oles')) {
            wordAux = word.replace('oles', 'ol');
          } else if (word.endsWith('os') || word.endsWith('as') || word.endsWith('es')) {
            wordAux = word.slice(0, word.length - 1);
          }
          accumulator.push(wordAux);
          return accumulator;
        }, [])
        .join(' ');
    },
    getCategoryFormat(categoryName = '') {
      const generalName = this.getGeneralName(categoryName);
      return this.getSingleName(generalName);
    },
    getPlayerTournamentBySelectedSeason(seasonId, tournaments) {
      const playerTournaments = this.user.related_seasons.reduce((accumulator, relatedSeason) => {
        const playerTournament = tournaments.get(relatedSeason);
        if (playerTournament) {
          accumulator.push(playerTournament._id);
        }
        return accumulator;
      }, []);
      const currentTournament = tournaments.get(seasonId);
      return playerTournaments.includes(currentTournament._id) ? currentTournament : null;
    },
    changeTournament(numberTournamentId) {
      if (['player', 'team'].includes(this.$route.name)) {
        return;
      }
      this.storeTournamentSelected(numberTournamentId);
      this.storeTournamentNameSelected(this.getTournaments[numberTournamentId].name);
    },
    changeSeason(numberSeasonId) {
      if (['player', 'team'].includes(this.$route.name)) {
        return;
      }
      this.storeSeasonSelected(numberSeasonId);
      this.storeSeasonNameSelected(this.getSeasons[this.getTournamentSelected][' ' + numberSeasonId].name);
    },

    getFilteredPlays(arrayFormattedPlays) {
      return arrayFormattedPlays.reduce((accumulator, objectPlay) => {
        if (this.objectMediaPlayerModeFilters.objectFilters.numberActionId > 1) {
          let booleanIsValidPlay = true;

          if (
            booleanIsValidPlay &&
            this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayPlayingAs
          ) {
            if ([3, 4].includes(this.actionId)) {
              booleanIsValidPlay = !(this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters
                .booleanRequiresRivalTransform &&
              this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayPlayingAs.length === 1
                ? objectPlay.teamId !==
                  this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.numberTeamId
                  ? this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayPlayingAs.includes(
                      objectPlay.playingAs,
                    )
                  : !this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayPlayingAs.includes(
                      objectPlay.playingAs,
                    )
                : !this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayPlayingAs.includes(
                    objectPlay.playingAs,
                  ));
            } else {
              booleanIsValidPlay = this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayPlayingAs.includes(
                objectPlay.playingAs,
              );
            }
          }

          if (
            booleanIsValidPlay &&
            this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayTimeSections
          ) {
            booleanIsValidPlay = this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayTimeSections.includes(
              objectPlay.section,
            );
          }

          if (
            booleanIsValidPlay &&
            this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.coordinatePoint &&
            this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayFieldSections
          ) {
            const playFieldArea =
              findFieldArea(
                objectPlay[`x${this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.coordinatePoint}`],
                objectPlay[`y${this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.coordinatePoint}`],
              ) + 1;
            const fieldAreaString = `${playFieldArea}`;
            const playFieldSectorAux = fieldSectorsFromSectionsIndex[fieldAreaString];
            const playFieldSector = this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters
              .requiresRivalTransform
              ? this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arraySelectedSubcategoryIds.includes(
                  `${objectPlay.categoryId}_r`,
                )
                ? fieldSectorsFromSectionsIndex[`${rivalFieldSectionsFromSectionsIndex[fieldAreaString]}`]
                : playFieldSectorAux
              : playFieldSectorAux;
            booleanIsValidPlay = !!this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayFieldSections.find(
              objectFieldSection => objectFieldSection.num === playFieldSector && objectFieldSection.status,
            );
          }

          if (booleanIsValidPlay) {
            accumulator.push(objectPlay);
          }
        } else {
          accumulator.push(objectPlay);
        }
        return accumulator;
      }, []);
    },

    async fillSeasonPlayers(objectSeason) {
      try {
        const arrayPlayers = await this.$store.dispatch(`mediaGeneral/getPlayersBySeasons`, {
          seasonId: objectSeason.id,
          returnData: true,
        });
        objectSeason.mapPlayers = new Map();
        objectSeason.mapPlayersByTeam = arrayPlayers.reduce((accumulator, objectPlayer) => {
          objectSeason.mapPlayers.set(objectPlayer.player_id, {
            id: objectPlayer.player_id,
            name: objectPlayer.player_name,
            shortName: objectPlayer.shortName,
            photo: objectPlayer.player_photo,
            teamId: objectPlayer.team_id,
            positionId: objectPlayer.position_id,
          });
          const arrayPlayersByTeam = accumulator.get(objectPlayer.team_id);
          if (arrayPlayersByTeam) {
            arrayPlayersByTeam.push(objectPlayer);
          } else {
            accumulator.set(objectPlayer.team_id, [objectPlayer]);
          }
          return accumulator;
        }, new Map());
      } catch (e) {
        throw new Error(e);
      }
    },
    async fillMatchDaysAndGamesV2(objectSeason) {
      try {
        const {
          seasonsAndGames: arraySeasonsAndGames,
          seasonsAndTeams: arraySeasonsAndTeams,
        } = await this.fetchSeasonsGamesAndTeamsV2(
          [objectSeason.id, ...objectSeason.related_seasons.map(objectRelatedSeason => objectRelatedSeason.id)],
          3,
        );
        const objectMainSeasonAndTeams = arraySeasonsAndTeams.find(
          objectSeasonAndTeams => objectSeasonAndTeams._id === objectSeason.id,
        );
        objectSeason.arrayTeams = [];
        objectSeason.mapTeams = new Map();
        const mapMainSeasonTeams = objectMainSeasonAndTeams.teams.reduce((accumulator, objectTeam) => {
          objectSeason.arrayTeams.push(objectTeam);
          objectSeason.mapTeams.set(objectTeam.team_id, {
            name: objectTeam.colloquial_name,
            acronym: objectTeam.acronym,
            logo: objectTeam.logo,
            id: objectTeam.team_id,
          });
          accumulator.set(objectTeam.team_id, objectTeam);
          return accumulator;
        }, new Map());
        objectSeason.mapGames = new Map();
        objectSeason.mapGamesByTeam = new Map();
        const arrayGamesByMatchDay = Array.from(
          arraySeasonsAndGames
            .reduce((accumulator, objectSeasonAndGames) => {
              objectSeasonAndGames.games.forEach(objectGame => {
                if (objectGame.game_status === 1 && objectGame.has_video) {
                  if (!objectSeason.maxGameId || objectGame.game_id > objectSeason.maxGameId) {
                    objectSeason.maxGameId = objectGame.game_id;
                  }
                  let abbreviation = objectGame.matchday_abbreviation.replace('M', 'J');
                  let name = objectGame.matchday_abbreviation.replace('M', 'Jornada ');
                  const roundNumberString = objectGame.matchday_abbreviation.replace('M', '');
                  if (objectSeasonAndGames.season_type === 0) {
                    if (this.objectMediaPlayerModeFilters.objectTournamentSelected.id === 33) {
                      if (objectGame.seasonId === 881) {
                        abbreviation = cupLegacyAbb[roundNumberString] || abbreviation;
                        name = cupLegacy[roundNumberString] || name;
                      } else {
                        abbreviation = cup[objectGame.matchday_abbreviation]
                          ? objectGame.matchday_abbreviation
                          : abbreviation;
                        name = cup[objectGame.matchday_abbreviation] || name;
                        if (abbreviation === 'FINAL') {
                          abbreviation = 'F';
                        }
                      }
                    }
                  } else if (objectSeasonAndGames.season_type === 1) {
                    abbreviation = regularLeague[objectGame.matchday_abbreviation];
                    name = abbreviation;
                  } else {
                    if (objectGame.matchday_id === 182) {
                      abbreviation = 'PI1';
                      name = 'Play In 1';
                    } else if (objectGame.matchday_id === 183) {
                      abbreviation = 'PI2';
                      name = 'Play In 2';
                    } else {
                      abbreviation = objectGame.matchday_abbreviation.replace('PO', 'R');
                      name = 'Repechaje';
                    }
                  }
                  objectGame.roundAbbreviation = abbreviation;
                  objectGame.roundName = name;
                  objectSeason.mapGames.set(objectGame.game_id, {
                    id: objectGame.game_id,
                    date: objectGame.date,
                    dateTimeMillis: new Date(objectGame.date_time_utc).valueOf(),
                    homeTeam: objectSeason.mapTeams.get(objectGame.home_team),
                    awayTeam: objectSeason.mapTeams.get(objectGame.visiting_team),
                    roundAbbreviation: objectGame.roundAbbreviation,
                    roundName: objectGame.roundName,
                    score: objectGame.score,
                    // 1 = local wins, 2 = away wins, 3 = tied
                    gameResult:
                      objectGame.score[0] > objectGame.score[1] ? 1 : objectGame.score[0] < objectGame.score[1] ? 2 : 3,
                    seasonId: objectSeasonAndGames.season_id,
                  });
                  const objectMatchDay = accumulator.get(objectGame.roundAbbreviation);
                  objectGame.numberDateTimeMillis = new Date(objectGame.date_time_utc).getTime();
                  objectGame.homeTeam = mapMainSeasonTeams.get(objectGame.home_team);
                  objectGame.awayTeam = mapMainSeasonTeams.get(objectGame.visiting_team);
                  const arrayGamesByHomeTeam = objectSeason.mapGamesByTeam.get(objectGame.home_team);
                  const arrayGamesByAwayTeam = objectSeason.mapGamesByTeam.get(objectGame.visiting_team);
                  if (arrayGamesByHomeTeam) {
                    arrayGamesByHomeTeam.push(objectGame);
                  } else {
                    objectSeason.mapGamesByTeam.set(objectGame.home_team, [objectGame]);
                  }
                  if (arrayGamesByAwayTeam) {
                    arrayGamesByAwayTeam.push(objectGame);
                  } else {
                    objectSeason.mapGamesByTeam.set(objectGame.visiting_team, [objectGame]);
                  }
                  if (objectMatchDay) {
                    objectMatchDay.arrayGames.push(objectGame);
                  } else {
                    accumulator.set(objectGame.roundAbbreviation, {
                      stringMatchDayAbbreviation: objectGame.roundAbbreviation,
                      stringMatchDayName: objectGame.roundName,
                      arrayGames: [objectGame],
                    });
                  }
                }
              });
              return accumulator;
            }, new Map())
            .values(),
        );
        arrayGamesByMatchDay.reverse();
        arrayGamesByMatchDay.forEach(objectMatchDay => {
          objectMatchDay.arrayGames.sort((a, b) => a.numberDateTimeMillis - b.numberDateTimeMillis);
        });
        objectSeason.arrayMatchDays = arrayGamesByMatchDay;
        this.objectMatchDaySelected = arrayGamesByMatchDay[0] || {};
      } catch (e) {
        throw new Error(e);
      }
    },
    /**
     * @author Alejandro Martinez
     * @param {Array<number>} seasons - seasons ids
     * @param {number} retries - Times to retry the request
     * @param {String} createdUrl - Url to make the request
     * @return {Promise<{seasonsAndGames: *, seasonsAndTeams: *}|*|undefined>}
     */
    async fetchSeasonsGamesAndTeamsV2(seasons, retries, createdUrl = '') {
      let gamesUrl = createdUrl;
      try {
        if (!gamesUrl) {
          gamesUrl = this.gamesUrl;
          seasons.forEach((seasonId, index) => {
            const prefix = index === 0 ? '' : '&';
            gamesUrl += `${prefix}seasons=${seasonId}`;
          });
        }
        const {
          data: { data, teams },
        } = await axios.get(gamesUrl);
        return { seasonsAndGames: data, seasonsAndTeams: teams };
      } catch (e) {
        if (retries > 0) {
          return this.fetchSeasonsGamesAndTeamsV2(seasons, retries - 1, gamesUrl);
        }
        throw new Error(e);
      }
    },
    async fillNextSeasonPlays() {
      try {
        this.showImage = true;
        this.playlistSeasonIndex++;
        this.seasonName = this.objectMediaPlayerModeFilters.objectTournamentSelected.arraySeasons[
          this.playlistSeasonIndex
        ].name;
        if (
          this.playlistSeasonIndex >
          this.objectMediaPlayerModeFilters.objectTournamentSelected.arraySeasons.length - 1
        ) {
          this.playlistSeasonIndex = 0;
        }
        const objectSeason = this.objectMediaPlayerModeFilters.objectTournamentSelected.arraySeasons[
          this.playlistSeasonIndex
        ];
        if (!objectSeason.arrayMatchDays) {
          await this.fillMatchDaysAndGamesV2(objectSeason);
          await this.fillSeasonPlayers(objectSeason);
        }
        const arrayPlays = await this.fetchPlays(
          objectSeason.id,
          this.objectMediaPlayerModeFilters.stringQueryCategoryIds,
          this.objectMediaPlayerModeFilters.stringQueryParams,
        );
        const arrayFormattedPlays = this.getFormattedPlays(arrayPlays, false, objectSeason);
        const arrayFilteredPlays = this.getFilteredPlays(arrayFormattedPlays);
        this.generatePlayerQueue(null, arrayFilteredPlays, false, 0, true);
      } catch (e) {
        throw new Error(e);
      }
    },
    onPlaylistEnded() {
      if (!this.booleanIsPlaySeekerMode) {
        if (this.isMyPlaylistsActive) {
          this.$store.commit('mediaModal/setPlaylistIndex', {
            mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
            playlistIndex: 0,
          });
        } else {
          if (this.booleanIsFilterApplied) {
            this.fillNextSeasonPlays();
          } else {
            this.playlistSeasonIndex++;
            if (this.playlistSeasonIndex > this.playlistTournament.seasons.length - 1) {
              this.playlistSeasonIndex = 0;
            }
            this.seasonName = this.playlistTournament.seasons[this.playlistSeasonIndex].name;
            this.showImage = true;
            setTimeout(() => {
              this.fetchInfo(false, this.playlistTournament);
            }, 4000);
          }
        }
      }
    },
    onTypeChanged(type = 1) {
      if (type !== this.selectedType || this.isModalMode) {
        if (this.isModalMode) {
          this.setPlayerType(type);
        }
        if (this.selectedType !== type || (this.isModalMode && type === 1)) {
          this.selectedType = type;
          if (this.selectedType === 2) {
            this.mediaPlayerMode = 'player';
            const player = this.summaryData
              ? { id: this.summaryData.id }
              : this.isModalMode
              ? this.isFirstTypeChange
                ? this.modalInitialState && this.modalInitialState.goalkeeperIds
                  ? {
                      id: this.modalInitialState.goalkeeperIds[0],
                      positionId: 1,
                    }
                  : { id: this.modalInitialState.playerIds[0] }
                : this.playInfo.player
              : this.isUserTournament
              ? null
              : this.playInfo.player;
            this.$store.commit(`${this.storeModule}/setPlayer`, player);
            this.$store.commit(
              `${this.storeModule}/setTeam`,
              this.isModalMode
                ? this.playInfo.teamId
                : this.isUserTournament
                ? this.gsData.teamId
                : this.playInfo.teamId,
            );
            this.onPlayerSelected();
          } else if (this.selectedType === 3) {
            this.mediaPlayerMode = 'team';
            const teamId = this.summaryData
              ? this.summaryData.id
              : this.isModalMode
              ? this.isFirstTypeChange
                ? this.modalInitialState && this.modalInitialState.teamId
                : this.playInfo.teamId
              : this.hasPlayerActivityInTournament || this.isUserTournament
              ? this.gsData.teamId
              : this.playInfo.teamId;
            this.$store.commit(`${this.storeModule}/setPlayer`, null);
            this.$store.commit(`${this.storeModule}/setTeam`, teamId);
            this.onTeamSelected();
          } else if (this.selectedType === 1) {
            this.mediaPlayerMode = 'games';
            this.$store.commit(`${this.storeModule}/setPlayer`, null);
            this.$store.commit(`${this.storeModule}/setTeam`, null);
            this.checkSeason();
          }
          if (type !== 0) {
            this.isFirstTypeChange = false;
          }
        }
      }
    },
    onMaxInactivityReached() {
      this.showModalConfirm = true;
    },
    checkSeason() {
      if (!this.gsData) {
        this.playlistSeasonIndex = this.playlistSeasonIndexAux;
      }
      const isSameSeason = this.getSeasonIdOnly === this.seasonId;
      this.fetchInfo(isSameSeason, this.playlistTournament);
    },
    onPlayerSelected() {
      this.mediaPlayerMode = 'player';
      this.checkSeason();
    },
    onTeamSelected() {
      this.mediaPlayerMode = 'team';
      this.checkSeason();
    },
    onGameIdSelected(gameId) {
      this.gameIdSelected = gameId;
    },
    onPlaying() {
      this.isAutoPlay = true;
    },
    onPlayChanged(play) {
      this.lastGameIdWatched = play.gameId;
      if (play.isPlaySeeker) {
        this.playInfo = play;
        this.objectPlaySeekerLastPlay = {
          playListId: play.payloadData.playlist_id,
          groupPlayListId: play.payloadData.group_playlist_id,
          groupId: play.payloadData.group_id,
          playIndex: play.payloadData.play_number - 1,
        };
        window.localStorage.setItem('playSeekerLastPlay', JSON.stringify(this.objectPlaySeekerLastPlay));
      } else if (play.booleanIsFullGame) {
        this.playInfo = {
          booleanIsFullGame: true,
          homeTeamLogo: play.objectGame.homeTeam.logo,
          homeTeamName: play.objectGame.homeTeam.colloquial_name,
          awayTeamLogo: play.objectGame.awayTeam.logo,
          awayTeamName: play.objectGame.awayTeam.colloquial_name,
          arrayScore: play.objectGame.score,
          gameId: play.gameId,
          seasonId: play.objectGame.season_id,
          dateTimeMillis: new Date(play.objectGame.date_time_utc).getTime(),
        };
      } else if (this.summaryData) {
        this.playInfo = {
          playId: play.playId,
          homeTeamLogo: play.game.homeTeam.logo,
          homeTeamName: play.game.homeTeam.colloquial_name || play.game.homeTeam.name,
          awayTeamLogo: play.game.awayTeam.logo,
          awayTeamName: play.game.awayTeam.colloquial_name || play.game.awayTeam.name,
          arrayScore: play.game.score,
          gameId: play.gameId,
          seasonId: play.seasonId,
          mainCategoryName: getCategoryFormat(play.mainCategory.name),
          playerShortName: play.player.shortName,
          dateTimeMillis: play.dateTimeMillis,
          playRaw: play.playRaw,
          startSeconds: play.startSeconds,
          endSeconds: play.endSeconds,
        };
      } else {
        if (this.isModalMode) {
          this.setPlaylistGameId(play.game.id);
          const subjectInfo =
            this.playerType === 2
              ? play.player.shortName
              : this.playerType === 3
              ? this.modalInitialState &&
                this.modalInitialState.isRivalSubject &&
                this.modalInitialState.mainSectionType === this.modalSectionSelected + 1
                ? // auto goals ids
                  [35, 54].includes(play.categoryId)
                  ? play.teamname
                  : play.rivalName
                : [35, 54].includes(play.categoryId)
                ? play.rivalName
                : play.teamName
              : '';
          this.$emit('subject-change', subjectInfo ? ` - ${subjectInfo}` : '');
        }
        this.playInfo = {
          playId: play.playId,
          date: play.gameDate,
          dateTimeMillis: play.dateTimeMillis,
          arrayScore: play.game.score,
          objectHomeTeam: play.game.homeTeam,
          objectAwayTeam: play.game.awayTeam,
          playerId: play.player.id,
          playerName: play.player.name,
          playerShortName: play.player.shortName,
          playCategory: play.categoryName,
          teams: `${play.game.homeTeam.name} vs ${play.game.awayTeam.name}`,
          playerPhoto: play.player.photo,
          teamLogo: play.playerTeamLogo,
          rivalLogo: play.rivalTeamLogo,
          teamId: play.teamId,
          categoryId: play.categoryId,
          jersey: play.jersey,
          mainCategoryName: getCategoryFormat(play.mainCategory.name || play.stringMainCategoryName || ''),
          categoriesNames: Array.from(play.categoriesNames.values()).reduce((accumulator, categoryName, index) => {
            // eslint-disable-next-line no-param-reassign
            accumulator += `${index === 0 ? '' : ', '}${categoryName}`;
            return accumulator;
          }, ''),
          gameId: play.game.id,
          roundAbbreviation: play.game.roundAbbreviation,
          player: play.player,
          asLocal: play.game.homeTeam.id === play.teamId,
          momentOfPlay: play.momentOfPlay,
          seasonId: play.seasonId,
          playRaw: play.playRaw,
          startSeconds: play.startSeconds,
          endSeconds: play.endSeconds,
          booleanIsFromMyPlaylists: play.booleanIsFromMyPlaylists,
        };
      }
    },
    async fetchPlays(numberSeasonId = null, stringQueryCategoryIds = null, stringQueryParams = null) {
      try {
        this.lastGameIdWatched = 0;
        let queryParams = '';
        if (stringQueryParams === null) {
          const areInitialPlayers =
            this.modalInitialState && this.modalInitialState.playerIds && this.modalInitialState.playerIds.length;
          if (this.modalInitialState.isFeaturedPlayers) {
            this.modalInitialState.playerIds.forEach(playerId => {
              queryParams += `&player=${playerId}`;
            });
            // only add players ids at first iteration when modal is opened
            this.modalInitialState.isFeaturedPlayers = false;
          } else if (this.getPlayerId) {
            if ((this.hasUserPlayerSelectedSeason && this.getPlayerId === this.user.player) || !this.user.is_player) {
              queryParams += `&player=${this.getPlayerId}`;
            }
          } else if (areInitialPlayers) {
            this.modalInitialState.playerIds.forEach(playerId => {
              queryParams += `&player=${playerId}`;
            });
          } else if (this.getTeamId || this.modalInitialState.teamId) {
            queryParams += `&team=${this.getTeamId || this.modalInitialState.teamId}`;
          }

          if (this.modalInitialState && this.modalInitialState.isPost) {
            queryParams += '&isPost=1';
          }
        }
        const response = await axios.get(
          // https://gpela9u46i.execute-api.us-west-2.amazonaws.com/prod/videos/plays/seasons/
          `https://cpj4073446.execute-api.us-east-2.amazonaws.com/prod/videos/plays/seasons/${numberSeasonId ||
            this.seasonId}?${stringQueryCategoryIds || this.queryCategories}${stringQueryParams || queryParams}`,
        );
        if (response.data && response.data.plays) {
          const plays = [...response.data.plays];
          if (response.data.plays_rival) {
            return plays.concat(response.data.plays_rival);
          }
          return plays;
        }
        return [];
      } catch (e) {
        throw new Error(e);
      }
    },
    async fetchInfo(isSameSeason, tournament) {
      try {
        if (!tournament) {
          return;
        }
        let playlistSeasonIndex = this.playlistSeasonIndex;
        this.playlistTournament = tournament;
        this.seasonId = tournament.seasons[playlistSeasonIndex].id;
        const promises = [this.fetchPlays()];
        if (!isSameSeason && tournament.seasons[playlistSeasonIndex]) {
          const seasons = [this.seasonId];
          if (
            tournament.seasons[playlistSeasonIndex].related_seasons &&
            tournament.seasons[playlistSeasonIndex].related_seasons.length
          ) {
            seasons.push(...tournament.seasons[playlistSeasonIndex].related_seasons.map(season => season.id));
          }
          promises.push(this.$store.dispatch(`${this.storeModule}/fetchSeasonsGamesAndTeams`, { seasons }));
          promises.push(
            this.$store.dispatch(`${this.storeModule}/getPlayersBySeasons`, {
              seasonId: this.seasonId,
            }),
          );
        }
        const [plays, gamesAndTeams] = await Promise.all(promises);
        this.plays = plays || [];
        if (this.hasPlayerActivityInTournament && !this.plays.length) {
          if (this.playlistSeasonIndex < this.playlistTournament.seasons.length - 1 && this.seasonSearchingCount < 1) {
            this.playlistSeasonIndex++;
            this.seasonSearchingCount++;
            await this.fetchInfo(false, tournament);
          } else {
            // this.setUpData(this.seasonSelected, true);
            // todo: refactor logic if there is no plays found, to avoid infinite bucle;
            return;
          }
        }
        if (!isSameSeason) {
          this.formatGamesAndTeams(gamesAndTeams);
        }
        const formattedPlays = this.getFormattedPlays(this.plays);

        this.generatePlayerQueue(
          this.currentCategories.reduce((accumulator, categoryString) => {
            if (!(typeof categoryString === 'string' && categoryString.includes('_'))) {
              accumulator.push(Number(categoryString));
            }
            return accumulator;
          }, []),
          formattedPlays,
        );
        this.showImage = false;
      } catch (e) {
        throw new Error(e);
      }
    },
    async fillSeasons(tournaments, isModalInitialStateEmpty = false) {
      try {
        if (tournaments) {
          let tournament = null;
          if (this.autoFillVideos) {
            tournament = tournaments.find(tournament => tournament._id === 1);
          } else {
            tournament = tournaments[0];
          }
          if (tournament) {
            this.currentTournament = tournament;
            if (this.isModalMode && !isModalInitialStateEmpty) {
              return;
            }
            await this.fetchInfo(false, this.currentTournament);
          }
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    async fillMyPlaylistsData(userPlaylistsSeasonsIds) {
      if (userPlaylistsSeasonsIds.length) {
        const promises = [
          this.$store.dispatch(`mediaGeneral/fetchSeasonsGamesAndTeams`, {
            seasons: userPlaylistsSeasonsIds,
          }),
        ];
        userPlaylistsSeasonsIds.forEach(seasonId => {
          promises.push(
            this.$store.dispatch(`mediaGeneral/getPlayersBySeasons`, {
              seasonId,
              returnData: true,
            }),
          );
        });
        const response = await Promise.all(promises);
        const gamesAndTeamsBySeasons = response.shift();
        this.formatGamesAndTeamsForMyPlaylists(gamesAndTeamsBySeasons);
        const playersMapMyPlaylists = response.reduce((accumulator, playersBySeason) => {
          playersBySeason.forEach(player => {
            accumulator.set(player.player_id, {
              id: player.player_id,
              name: player.player_name,
              shortName: player.shortName,
              photo: player.player_photo,
              teamId: player.team_id,
              positionId: player.position_id,
            });
          });
          return accumulator;
        }, new Map());
        this.setPlayersMapMyPlaylists(playersMapMyPlaylists);
      }
    },
    getBestPlaysCategoriesIds() {
      return Object.keys(bestPlaysCategories[this.mediaPlayerMode]).reduce((accumulator, categoryId) => {
        categoryId.split('-').forEach(categoryIdString => {
          accumulator.push(Number(categoryIdString));
        });
        return accumulator;
      }, []);
    },
    setUpMediaGeneralData() {
      if (['player', 'team'].includes(this.$route.name)) {
        this.$store.commit('mediaGeneral/setObjectMediaData', null);
      } else {
        const { objectCurrentPlay, numberCurrentTime } = this.$refs.videoPlayer.getCurrentPlayerPlayInfo();
        const objectPlaySync = {
          numberPlayId: objectCurrentPlay.playId,
          numberCurrentTime,
        };
        const objectData = {
          arrayPlayerQueue: [...this.playerQueue],
          stringModeTitle: this.stringModeTitle,
          numberPlaylistIndex: this.playlistIndex,
          numberPlaylistSeasonIndex: this.playlistSeasonIndex,
          booleanIsFilterApplied: this.booleanIsFilterApplied,
          booleanIsPlaySeekerMode: this.booleanIsPlaySeekerMode,
          booleanAvoidApply:
            this.isModalMode &&
            this.modalInitialState &&
            this.modalInitialState.avoidApply &&
            !this.booleanIsFilterApplied,
          objectPlaySync,
        };
        if (this.booleanIsFilterApplied) {
          objectData.objectLastDataToFilter = this.objectLastDataToFilter;
        }
        this.$store.commit('mediaGeneral/setObjectMediaData', objectData);
      }
    },
    formatGamesAndTeams(gamesAndTeams) {
      this.roundsMap = new Map();
      this.teamsMap = gamesAndTeams.seasonsAndTeams.reduce((accumulator, season) => {
        if (season) {
          season.teams.forEach(team => {
            if (!accumulator.has(team.team_id)) {
              accumulator.set(team.team_id, {
                name: team.colloquial_name,
                acronym: team.acronym,
                logo: team.logo,
                id: team.team_id,
                players: this.playersByTeam.get(team.team_id),
              });
            }
          });
        }
        return accumulator;
      }, new Map());
      this.gamesMap = gamesAndTeams.seasonsAndGames.reduce((accumulator, season) => {
        const isCup = !!(
          this.currentTournament &&
          this.currentTournament.tournament &&
          this.currentTournament.tournament.tournament_type
        );
        season.games.forEach(game => {
          game.seasonType = season.season_type;
          game.seasonId = season.season_id;
          if (game.game_id > this.maxGameId) {
            this.maxGameId = game.game_id;
          }
          let abbreviation = game.matchday_abbreviation.replace('M', 'J');
          let name = game.matchday_abbreviation.replace('M', 'Jornada ');
          const roundNumberString = game.matchday_abbreviation.replace('M', '');
          if (game.seasonType === 0) {
            if (isCup) {
              if (game.seasonId === 881) {
                abbreviation = cupLegacyAbb[roundNumberString] || abbreviation;
                name = cupLegacy[roundNumberString] || name;
              } else {
                abbreviation = cup[game.matchday_abbreviation] ? game.matchday_abbreviation : abbreviation;
                name = cup[game.matchday_abbreviation] || name;
                if (abbreviation === 'FINAL') {
                  abbreviation = 'F';
                }
              }
            }
          } else if (game.seasonType === 1) {
            abbreviation = regularLeague[game.matchday_abbreviation];
            name = abbreviation;
          } else {
            if (game.matchday_id === 182) {
              abbreviation = 'PI1';
              name = 'Play In 1';
            } else if (game.matchday_id === 183) {
              abbreviation = 'PI2';
              name = 'Play In 2';
            } else {
              abbreviation = game.matchday_abbreviation.replace('PO', 'R');
              name = 'Repechaje';
            }
          }
          game.roundAbbreviation = abbreviation;
          game.roundName = name;
          const gameAux = {
            id: game.game_id,
            date: game.date,
            dateTimeMillis: new Date(game.date_time_utc).valueOf(),
            homeTeam: this.teamsMap.get(game.home_team),
            awayTeam: this.teamsMap.get(game.visiting_team),
            roundAbbreviation: game.roundAbbreviation,
            roundName: game.roundName,
            score: game.score,
            // 1 = local wins, 2 = away wins, 3 = tied
            gameResult: game.score[0] > game.score[1] ? 1 : game.score[0] < game.score[1] ? 2 : 3,
            seasonId: season.season_id,
          };
          const round = this.roundsMap.get(game.roundAbbreviation);
          if (round) {
            round.push(gameAux);
          } else {
            this.roundsMap.set(game.roundAbbreviation, [gameAux]);
          }
          if (!accumulator.has(game.game_id)) {
            accumulator.set(game.game_id, gameAux);
          }
        });
        return accumulator;
      }, new Map());
    },
    formatGamesAndTeamsForMyPlaylists(gamesAndTeams) {
      const teamsMapMyPlaylists = gamesAndTeams.seasonsAndTeams.reduce((accumulator, season) => {
        if (season) {
          season.teams.forEach(team => {
            if (!accumulator.has(team.team_id)) {
              accumulator.set(team.team_id, {
                name: team.colloquial_name,
                acronym: team.acronym,
                logo: team.logo,
                id: team.team_id,
                players: this.playersByTeam.get(team.team_id),
              });
            }
          });
        }
        return accumulator;
      }, new Map());
      let maxGameIdMyPlaylists = 0;
      const gamesMapMyPlaylists = gamesAndTeams.seasonsAndGames.reduce((accumulator, season) => {
        season.games.forEach(game => {
          game.seasonType = season.season_type;
          game.seasonId = season.season_id;
          if (game.game_id > maxGameIdMyPlaylists) {
            maxGameIdMyPlaylists = game.game_id;
          }
          const gameAux = {
            id: game.game_id,
            date: game.date,
            dateTimeMillis: new Date(game.date_time_utc).valueOf(),
            homeTeam: teamsMapMyPlaylists.get(game.home_team),
            awayTeam: teamsMapMyPlaylists.get(game.visiting_team),
            roundAbbreviation: game.matchday_abbreviation,
            roundName: game.matchday_abbreviation.replace('M', 'MatchDay '),
            score: game.score,
            // 1 = local wins, 2 = away wins, 3 = tied
            gameResult: game.score[0] > game.score[1] ? 1 : game.score[0] < game.score[1] ? 2 : 3,
            seasonId: season.season_id,
          };
          if (!accumulator.has(game.game_id)) {
            accumulator.set(game.game_id, gameAux);
          }
        });
        return accumulator;
      }, new Map());
      this.setTeamsMapMyPlaylists(teamsMapMyPlaylists);
      this.setGamesMapMyPlaylists(gamesMapMyPlaylists);
      this.setMaxGameIdMyPlaylists(maxGameIdMyPlaylists);
    },
    onPlayerModeClicked(modeId) {
      this.playerModeSelected = modeId;
    },
    onClickModalLauncher(numberMainSectionType = 1) {
      const { objectCurrentPlay, numberCurrentTime } = this.$refs.videoPlayer.getCurrentPlayerPlayInfo();
      const objectPlaySync = {
        numberPlayId: objectCurrentPlay.playId,
        numberCurrentTime,
      };
      this.$refs.videoPlayer.pausePlayers();
      let modalInitialState = null;
      if (
        (!numberMainSectionType && this.booleanIsFilterApplied) ||
        this.objectMediaPlayerModeFilters.objectSeasonSelected ||
        this.booleanIsPlaySeekerMode ||
        this.booleanIsFilterApplied
      ) {
        // modalInitialState = {
        //   seasonId: this.objectMediaPlayerModeFilters.objectTournamentSelected.arraySeasons[this.playlistSeasonIndex]
        //     .id,
        //   tournaments: this.tournamentsForModalLauncher,
        //   categoryIds: [...this.arrayCategoriesIdsRaw],
        //   mainSectionType:
        //     this.objectMediaPlayerModeFilters.objectFilters.numberActionId === 1
        //       ? 1
        //       : this.objectMediaPlayerModeFilters.objectFilters.objectCategorySelected.booleanIsBestPlays
        //       ? 2
        //       : 3,
        //   playListType:
        //     this.objectMediaPlayerModeFilters.objectFilters.numberActionId === 1
        //       ? 1
        //       : this.objectMediaPlayerModeFilters.objectFilters.numberActionId === 2
        //       ? 1
        //       : this.objectMediaPlayerModeFilters.objectFilters.numberActionId === 3
        //       ? 3
        //       : 2,
        //   matchResult: [1, 2, 3],
        //   advancedFilter:
        //     this.objectMediaPlayerModeFilters.objectFilters.numberActionId === 1
        //       ? null
        //       : {
        //           playListTitle: !this.objectMediaPlayerModeFilters.objectFilters.objectCategorySelected
        //             .booleanIsBestPlays
        //             ? this.objectMediaPlayerModeFilters.objectFilters.objectCategorySelected.name
        //             : '',
        //           mainCategoryId: {},
        //           playingAs: this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayPlayingAs,
        //           timeSections: this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayTimeSections,
        //           fieldSectors: this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters
        //             .arrayFieldSections,
        //           coordinatePoint: this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters
        //             .numberCoordinatePoint,
        //         },
        //   currentPlayIndex: this.playlistIndex,
        // };
        // if (this.objectMediaPlayerModeFilters.objectFilters.numberActionId === 4) {
        //   if (this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.booleanIsPlayerGoalKeeper) {
        //     modalInitialState.goalkeeperIds = [
        //       this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.numberPlayerId,
        //     ];
        //   } else {
        //     modalInitialState.playerIds = [
        //       this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.numberPlayerId,
        //     ];
        //   }
        // }
        // if (this.objectMediaPlayerModeFilters.objectFilters.numberActionId === 3) {
        //   modalInitialState.teamId = this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.numberTeamId;
        // }
        const objectData = {
          arrayPlayerQueue: [...this.playerQueue],
          stringModeTitle: this.stringModeTitle,
          numberPlaylistIndex: this.playlistIndex,
          numberPlaylistSeasonIndex: this.playlistSeasonIndex,
          booleanIsPlaySeekerMode: this.booleanIsPlaySeekerMode,
          numberMainSectionType: numberMainSectionType,
          objectPlaySync,
        };
        objectData.booleanIsFilterApplied = this.booleanIsFilterApplied;
        if (this.booleanIsFilterApplied) {
          objectData.objectLastDataToFilter = this.objectLastDataToFilter;
        }
        this.$store.commit('mediaModal/setModalInitialState', null);
        this.$store.commit('mediaModal/setObjectMediaData', objectData);
      } else {
        modalInitialState = {
          seasonId: this.seasonId,
          tournaments: this.tournamentsForModalLauncher,
          categoryIds: [...this.currentCategories],
          mainSectionType: numberMainSectionType,
          matchResult: [1, 2, 3],
          currentPlayIndex: this.playlistIndex,
          objectPlaySync,
        };
        if (this.getPlayerId) {
          if (this.isPlayerGoalkeeper) {
            modalInitialState.goalkeeperIds = [this.getPlayerId];
          } else {
            modalInitialState.playerIds = [this.getPlayerId];
          }
        } else if (this.getTeamId) {
          modalInitialState.teamId = this.getTeamId;
        }
        this.$store.commit('mediaModal/setObjectMediaData', null);
        this.$store.commit('mediaModal/setModalInitialState', modalInitialState);
      }
      this.$store.commit('mediaModal/setIsModalOpen', true);
    },
    setUpResizeObserver() {
      if (window.ResizeObserver) {
        this.mediaPlayerResizeObserver = new window.ResizeObserver(() => {
          this.mediaPlayerWidth = this.$refs.mediaPlayer.clientWidth;
        });
        this.mediaPlayerResizeObserver.observe(this.$refs.mediaPlayer);
      } else {
        throw new Error('Resize observer not supported!');
      }
    },
    async onClickDownload() {
      try {
        let stringVideoUrl = '';
        this.setIsSectionLoading(true);
        if (this.playInfo.booleanIsFullGame) {
          stringVideoUrl = `https://golstatsbets.blob.core.windows.net/video-player/${this.playInfo.gameId}_1.mp4`;
          saveAs(stringVideoUrl, `partido-completo_${this.playInfo.playerShortName}.mp4`);
          this.setIsSectionLoading(false);
        } else {
          const objectResponse = await axios.post(
            'https://p6glojlzf2.execute-api.us-east-2.amazonaws.com/prod/download',
            {
              play_id: this.playInfo.playId,
              start_time: this.playInfo.startSeconds,
              end_time: this.playInfo.endSeconds,
              game_id: this.playInfo.gameId,
            },
          );
          if (objectResponse.data.url) {
            stringVideoUrl = objectResponse.data.url;
            fetch(stringVideoUrl)
              .then(response => {
                return response.blob();
              })
              .then(blob => {
                saveAs(
                  blob,
                  `${this.playInfo.playId}_${this.playInfo.mainCategoryName}_${this.playInfo.playerShortName}.mp4`,
                );
                this.setIsSectionLoading(false);
              });
          }
        }
      } catch (error) {
        throw new Error(error);
      } finally {
        this.setIsSectionLoading(false);
      }
    },
    onClickMyPlaylists() {
      if (this.isModalMode) {
        this.$store.commit('mediaModal/setModalSectionSelected', 2);
      } else {
        this.onClickModalLauncher(2);
      }
    },
    getEmptyMediaPlayerModeFilters() {
      return {
        objectTournamentSelected: null,
        objectSeasonSelected: null,
        stringQueryCategoryIds: '',
        stringQueryParams: '',
        objectFilters: {
          numberActionId: 0,
          numberMediaPlayerType: null,
          objectCategorySelected: null,
          objectAdvancedFilters: {
            numberTeamId: null,
            numberPlayerId: null,
            arraySelectedSubcategoryIds: [],
            booleanRequiresRivalTransform: false,
            numberCoordinatePoint: 2,
            arrayPlayingAs: [],
            arrayTimeSections: [],
            arrayFieldSections: [],
          },
        },
      };
    },
    fillDataToFilterData(objectDataToFilter) {
      this.objectLastDataToFilter = objectDataToFilter;
      this.arrayCategoriesIdsToFilter = objectDataToFilter.arrayCategoriesIds;
      this.arrayRivalCategoriesIdsToFilter = objectDataToFilter.arrayRivalCategoriesIds;
      this.arrayCategoriesIdsRaw = objectDataToFilter.arrayCategoriesIdsRaw;

      this.objectMediaPlayerModeFilters.stringQueryCategoryIds = objectDataToFilter.stringQueryCategoryIds;
      this.objectMediaPlayerModeFilters.stringQueryParams = objectDataToFilter.stringQueryParams;
      this.objectMediaPlayerModeFilters.objectTournamentSelected = objectDataToFilter.objectTournamentSelected;
      this.objectMediaPlayerModeFilters.objectSeasonSelected = objectDataToFilter.objectSeasonSelected;
      this.objectMediaPlayerModeFilters.objectGameSelected = objectDataToFilter.objectGameSelected;
      this.objectMediaPlayerModeFilters.objectFilters.numberMediaPlayerType =
        objectDataToFilter.objectFilters.numberMediaPlayerType;
      this.objectMediaPlayerModeFilters.objectFilters.objectCategorySelected =
        objectDataToFilter.objectFilters.objectCategorySelected;
      this.objectMediaPlayerModeFilters.objectFilters.numberActionId = objectDataToFilter.objectFilters.numberActionId;

      this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.numberTeamId =
        objectDataToFilter.objectFilters.objectAdvancedFilters.numberTeamId;
      this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.numberPlayerId =
        objectDataToFilter.objectFilters.objectAdvancedFilters.numberPlayerId;
      this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.booleanIsPlayerGoalKeeper =
        objectDataToFilter.objectFilters.objectAdvancedFilters.booleanIsPlayerGoalKeeper;
      this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arraySelectedSubcategoryIds =
        objectDataToFilter.objectFilters.objectAdvancedFilters.arraySelectedSubcategoryIds;
      this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.booleanRequiresRivalTransform =
        objectDataToFilter.objectFilters.objectAdvancedFilters.booleanRequiresRivalTransform;
      this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.numberCoordinatePoint =
        objectDataToFilter.objectFilters.objectAdvancedFilters.numberCoordinatePoint;
      this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayPlayingAs =
        objectDataToFilter.objectFilters.objectAdvancedFilters.arrayPlayingAs;
      this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayTimeSections =
        objectDataToFilter.objectFilters.objectAdvancedFilters.arrayTimeSections;
      this.objectMediaPlayerModeFilters.objectFilters.objectAdvancedFilters.arrayFieldSections =
        objectDataToFilter.objectFilters.objectAdvancedFilters.arrayFieldSections;

      this.selectedType = objectDataToFilter.numberSelectedType;
    },
    onClickApplyFilters(objectDataToFilter) {
      this.stringModeTitle = `Estas viendo: ${objectDataToFilter.stringControlsTitle}`;
      this.booleanIsPlaySeekerMode = false;
      this.booleanIsFilterApplied = true;
      this.fillDataToFilterData(objectDataToFilter);
      this.playlistSeasonIndex = objectDataToFilter.objectTournamentSelected.numberSeasonSelectedIndex;
      if (objectDataToFilter.objectTournamentSelected.id !== this.getTournamentSelected) {
        this.changeTournament(objectDataToFilter.objectTournamentSelected.id);
      }
      if (objectDataToFilter.objectSeasonSelected) {
        this.changeSeason(objectDataToFilter.objectSeasonSelected.id);
      }
      this.generatePlayerQueue(
        null,
        objectDataToFilter.arrayFormattedPlays,
        false,
        objectDataToFilter.numberPlaylistIndex,
        true,
      );
    },
    onClickOptions(objectCoordinates) {
      this.booleanIsOptionsMenuVisible = true;
      this.numberOptionsMenuTop = objectCoordinates.numberY;
      this.numberOptionsMenuLeft = objectCoordinates.numberX;
    },
    onClickOpenModes() {
      this.$refs.videoPlayer.pausePlayers();
      this.booleanIsModesModalOpen = true;
    },
    onClickFullGame(objectData) {
      this.booleanIsPlaySeekerMode = false;
      this.booleanIsFilterApplied = true;
      const numberSelectedGameIndex = objectData.arrayMatchDayGames.findIndex(
        objectGame => objectGame.game_id === objectData.objectGame.game_id,
      );
      if (numberSelectedGameIndex !== -1) {
        if (objectData.objectTournamentSelected.id !== this.getTournamentSelected) {
          this.changeTournament(objectData.objectTournamentSelected.id);
        }
        if (objectData.objectSeasonSelected.id !== this.getSeasonSelected) {
          this.changeSeason(objectData.objectSeasonSelected.id);
        }
        this.stringModeTitle = `Estas viendo: ${objectData.stringControlsTitle}`;
        this.booleanIsPlaySeekerMode = false;
        this.playerQueue = objectData.arrayMatchDayGames.map(objectGame => {
          objectGame.homeTeam.name = objectGame.homeTeam.colloquial_name;
          objectGame.awayTeam.name = objectGame.awayTeam.colloquial_name;
          return {
            booleanIsFullGame: true,
            objectGame,
            gameId: objectGame.game_id,
            startSeconds: 0,
            endSeconds: null,
          };
        });
        this.$store.commit(`${this.storeModule}/setPlaylistIndex`, {
          mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
          playlistIndex: numberSelectedGameIndex,
        });
        if (this.isModalMode) {
          this.$store.commit('mediaModal/setCurrentPlayerQueue', this.playerQueue);
        }
      }
    },
    onModesModalClose() {
      this.booleanIsModesModalOpen = false;
      this.onClickSpeed(1);
    },
    onClickMode() {
      this.$refs.videoPlayer.setSpeedToAllPlayers(1);
    },
    // PlaySeeker ----------------------------------------------------------
    onClickSurpriseMe() {
      this.booleanIsFilterApplied = false;
      this.booleanIsPlaySeekerMode = true;
      this.fillPlaySeekerPlays();
    },
    getPlaySeekerCategoryName(objectPlay) {
      if (objectPlay.categoryId === 33) {
        return 'Fuera de lugar';
      } else {
        // auto goals ids
        if ([35, 54].includes(objectPlay.categoryId)) {
          return 'Auto gol';
        } else {
          const objectCategoryAux =
            this.allCategories.get(objectPlay.categoryId) ||
            this.allCategories.get(`${objectPlay.categoryId}_r`) ||
            this.extraCategories.get(objectPlay.categoryId) ||
            this.extraCategories.get(`${objectPlay.categoryId}_r`);
          return objectCategoryAux ? objectCategoryAux.name : 'S/N';
        }
      }
    },
    async setUpTokens() {
      try {
        const response = await fetch(`${this.firstInteractionUrl}/token`, {
          method: 'POST',
          mode: 'cors',
          headers: {
            Authorization: 'Basic bXN1c2VyQWRtaW46bXN1c2VycGFzc3dvcmRBZG1pbg==',
          },
          referrerPolicy: 'no-referrer',
        });
        const data = await response.json();
        this.firstInteractionToken = data.token;
      } catch (e) {
        throw new Error(e);
      }
    },
    async fillPlaySeekerPlays(/*booleanRefreshQueueData*/) {
      try {
        this.stringModeTitle = 'Sorpréndeme';
        // if (booleanRefreshQueueData) {
        //   this.playerQueue = [];
        //   this.$refs.videoPlayer.resetCurrentPlayIndex();
        // }
        if (this.booleanIsPlaySeekerMode) {
          const response = await fetch(
            `${this.firstInteractionUrl}/firstInteraction/${playSeekerClientId}/${this.user.username}/playlist`,
            {
              method: 'GET',
              headers: {
                Authorization:
                  // eslint-disable-next-line max-len
                  `Bearer ${this.firstInteractionToken}`,
              },
              referrerPolicy: 'no-referrer',
            },
          );
          const data = await response.json();
          if (data) {
            this.setPlaySeekerUserId(data.user_id);
            this.setPlaySeekerCurrentSessionId(this.getPlaySeekerSessionId(this.playSeekerUserId));
            this.$emit('change-user-id', this.playSeekerUserId);
            window.localStorage.setItem('playSeekerUserId', this.playSeekerUserId);
            this.formatPlaySeekerPlays(data);
          }
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    formatPlaySeekerPlays(listData) {
      let formattedPlays = [];
      if (listData && listData.playlist && listData.playlist.length) {
        formattedPlays = listData.playlist.reduce((accumulator, play, index) => {
          const playObject = Object.entries(playSeekerContentIndexes).reduce((accumulator, [key, value]) => {
            accumulator[key] = play[value];
            return accumulator;
          }, {});
          const playInfo = {
            ...playObject,
            isPlaySeeker: true,
            startSeconds: play[playSeekerContentIndexes.startTime],
            endSeconds: play[playSeekerContentIndexes.endTime],
            totalSeconds: Math.floor(play[playSeekerContentIndexes.endTime] - play[playSeekerContentIndexes.startTime]),
            payloadData: {
              play_id: play[playSeekerContentIndexes.playId],
              total_plays: listData.total_plays,
              play_number: index + 1,
              group_playlist_id: listData.group_playlist_id,
              playlist_id: listData.playlist_id,
              group_id: listData.group_id,
              moment_of_play: play[playSeekerContentIndexes.momentOfPlay],
              play_type: play[playSeekerContentIndexes.categoryId],
              viewer_second_start: Math.floor(play[playSeekerContentIndexes.startTime]),
              intended_second_start: Math.floor(play[playSeekerContentIndexes.startTime]),
              intended_second_end: Math.floor(play[playSeekerContentIndexes.endTime]),
              latitude_of_user: null,
              longitude_of_user: null,
            },
          };
          const [lastName, name] = playInfo.playerName.split(',');
          const lastNameArr = lastName.split(' ');
          let lastNameShort = '';
          for (const word of lastNameArr) {
            lastNameShort += ` ${word}`;
            if (word.length > 3) {
              break;
            }
          }
          playInfo.playerShortName = name && lastName ? `${name.trim().charAt(0)}.${lastNameShort}` : '';
          if (!playInfo.mainCategoryName) {
            playInfo.mainCategoryName = getCategoryFormat(this.getPlaySeekerCategoryName(playInfo));
            const [homeScore, awayScore] = playInfo.finalScore.split(' - ');
            playInfo.arrayScore = [Number(homeScore), Number(awayScore)];
          }
          accumulator.push(playInfo);
          return accumulator;
        }, []);
      }
      let arrayPlayerQueue = [];
      if (this.concatPlays) {
        arrayPlayerQueue = [...this.playerQueue.splice(0, this.currentPlayIndex + 1), ...formattedPlays];
      } else {
        arrayPlayerQueue = formattedPlays;
      }
      this.playerQueue = arrayPlayerQueue;
      if (
        this.objectPlaySeekerLastPlay &&
        this.objectPlaySeekerLastPlay.playListId === listData.playlist_id &&
        this.objectPlaySeekerLastPlay.groupPlayListId === listData.group_playlist_id &&
        this.objectPlaySeekerLastPlay.groupId === listData.group_id
      ) {
        this.$store.commit(`${this.storeModule}/setPlaylistIndex`, {
          mediaPlayerType: !this.isModalMode ? this.mediaPlayerType : null,
          playlistIndex: this.objectPlaySeekerLastPlay.playIndex,
        });
      }
      if (this.isModalMode) {
        this.$store.commit('mediaModal/setCurrentPlayerQueue', this.playerQueue);
      }
    },

    getPlaySeekerSessionId(userId) {
      if (userId) {
        return `S_${userId}${Date.now()}`;
      }
      return null;
    },

    getRandomPercentage() {
      return Math.floor(Math.random() * (80 - 20) + 20);
    },

    /**
     *
     * @param {number} playerTime
     * @param {number} userAction - values can be: 0 = next clicked, 1 = play ended, 2 = back clicked
     * @param {string} dateTimeIsoString
     */
    async sendUserBehavior(playerTime, userAction, dateTimeIsoString) {
      try {
        if (this.playInfo.isPlaySeeker) {
          const payload = {
            user_id: this.playSeekerUserId,
            current_session_id: this.playSeekerCurrentSessionId,
            last_play: {
              ...this.playInfo.payloadData,
            },
          };
          if (payload) {
            payload.last_play.action = userAction;
            payload.last_play.percentage_viewed = userAction === 1 ? 100 : this.getRandomPercentage();
            payload.last_play.viewer_second_end = playerTime || this.playInfo.endSeconds;
            payload.last_play.date_time_of_user_action = dateTimeIsoString;
            if (this.coords) {
              payload.last_play.latitude_of_user = this.coords.latitude;
              payload.last_play.longitude_of_user = this.coords.latitude;
            }
          }
          const response = await fetch(`${this.userBehaviorUrl}/user-behavior`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });
          if (response.status === 200) {
            const data = await response.json();
            if (data) {
              this.concatPlays = true;
              this.formatPlaySeekerPlays(data);
            }
          } else {
            this.concatPlays = false;
          }
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    onGeoSuccess($event) {
      this.coords = $event.coords;
    },
    onGeoError(error) {
      throw new Error(error);
    },
    onClickTimeButton(objectTimeButton) {
      if (objectTimeButton.numberType === 1) {
        this.$refs.videoPlayer.addSecondsToCurrentPlayer(
          objectTimeButton.numberValue * objectTimeButton.numberValueFactor,
        );
      } else if (objectTimeButton.numberType === 2) {
        this.booleanIsSpeedModalVisible = true;
      } else {
        this.booleanIsVideoPlayerPlaying
          ? this.$refs.videoPlayer.pausePlayers()
          : this.$refs.videoPlayer.playCurrentPlayer();
      }
    },
    onClickOption(numberOptionId) {
      this.$refs.videoPlayer.pausePlayers();
      if (numberOptionId === 1) {
        EventBus.$emit('click-game', {
          gameId: this.playInfo.gameId,
          gameStatus: 1,
          dateTimeUTC: new Date(this.playInfo.dateTimeMillis).toISOString(),
          seasonId: this.playInfo.seasonId,
          stringSectionName: 'lineups',
        });
      } else if (numberOptionId === 2) {
        this.onClickDownload();
      } else if (numberOptionId === 3) {
        this.setPlaysToSaveAsFavorites([this.playInfo.playRaw]);
        this.setIsModalCreatePlayListOpen(true);
      } else if (numberOptionId === 4) {
        if (this.isModalMode) {
          this.$emit('show-list');
        } else {
          this.onClickModalLauncher();
        }
      }
    },
    onClickNextBack(stringType) {
      this.$refs.videoPlayer.onMoveToPlayClicked(stringType);
    },
    onPlayIteration({ iterationTime, userAction, dateTimeIsoString }) {
      if (this.booleanIsPlaySeekerMode) {
        this.sendUserBehavior(iterationTime, userAction, dateTimeIsoString);
      }
    },
    onClickAnalyst() {
      this.onClickModalLauncher();
    },
    onClickFullscreen() {
      this.$refs.videoPlayer.setFullscreen();
    },
    onChangeSeason(numberSeasonId) {
      this.numberCurrentSeasonId = Number(numberSeasonId);
      this.isAutoPlay = false;
      this.objectMediaPlayerModeFilters = this.getEmptyMediaPlayerModeFilters();
      this.setUpData(numberSeasonId);
    },
  },
  async created() {
    try {
      EventBus.$on('change-season', this.onChangeSeason);
      navigator.geolocation.getCurrentPosition(this.onGeoSuccess, this.onGeoError, this.geoOptions);
      await this.setUpTokens();
      EventBus.$on('some-list-selected', () => {
        this.isSomeListSelected = true;
      });
      if (this.autoFillVideos) {
        await this.$store.dispatch(`${this.storeModule}/fetchTournaments`);
      }
    } catch (e) {
      throw new Error(e);
    }
  },
  mounted() {
    const stringPlaySeekerLastPlay = window.localStorage.getItem('playSeekerLastPlay');
    this.objectPlaySeekerLastPlay = stringPlaySeekerLastPlay ? JSON.parse(stringPlaySeekerLastPlay) : null;
    if (this.isModalMode) {
      if (this.modalInitialState) {
        this.objectPlaySync = this.modalInitialState.objectPlaySync
          ? { ...this.modalInitialState.objectPlaySync, booleanIsApplied: false }
          : null;
        this.setUpData(this.modalInitialState.seasonId);
        this.onTypeChanged(this.modalInitialState.playListType);
        this.$store.commit('mediaModal/setModalSectionSelected', this.modalInitialState.mainSectionType || 1);
        this.stringModeTitle = `Estas viendo: ${
          this.modalInitialState.teamId
            ? 'Resumen de equipo'
            : this.modalInitialState.playerIds && this.modalInitialState.playerIds.length
            ? 'Resumen de jugador'
            : this.modalInitialState.gameIds && this.modalInitialState.gameIds.length
            ? 'Resumen de partido'
            : ''
        }`;
      } else if (this.objectMediaData) {
        this.$store.commit('mediaModal/setModalSectionSelected', 1);
        this.applyObjectMediaData();
      }
    } else if (
      this.seasonSelected &&
      ['bets', 'landing'].includes(this.$route.name) &&
      this.tournamentsForMediaPlayer.size > 0
    ) {
      this.setUpData(this.seasonSelected);
      this.setInitialTitle();
    }
    setTimeout(() => {
      this.setUpResizeObserver();
    }, 1000);
    if (!this.userPlaylists.length && (this.booleanIsFromMexico || this.getIsGSUser)) {
      this.setUpUserPlaylists();
    }
  },
  beforeDestroy() {
    this.isSomeListSelected = false;
    if (this.mediaPlayerResizeObserver) {
      this.mediaPlayerResizeObserver.disconnect();
      this.mediaPlayerResizeObserver = null;
    }
    this.$store.commit(`${this.storeModule}/setPlayer`, null);
    this.$store.commit(`${this.storeModule}/setTeam`, null);
    this.setPlaylistGameId(0);
  },
};
</script>
<style lang="scss">
.is-fullheight-with-navbar-and-footer,
.is-fullheight-with-navbar-and-footer-mobile {
  height: calc(100% - 1px);
}
</style>
<style lang="scss" scoped>
$blue: #132739;
$green: #cbee6b;

.media-player {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1rem;

  &__header {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $blue;
    border-bottom: solid 3px $green;
    font-family: Avenir-Demi, sans-serif;

    &__icon {
      position: absolute;
      left: 0;
      height: 32px;
      margin-left: 0.5rem;

      & > img {
        width: 28px;
        height: auto;
      }
    }

    &__modal-launcher {
      position: absolute;
      right: 0.5em;
      display: flex;
      height: 2.2em;
      justify-content: center;
      align-items: center;
      font-size: 0.875em;
      border-radius: 8px;
      border: solid 1.3px #cbee6b;
      color: $green;
      background-color: $blue;
      padding: 0 1em;
      cursor: pointer;

      & > div.plus {
        height: 14px;
        width: 14px;
        display: none;
      }

      @media screen and (max-width: 674px) {
        & > div.text {
          display: none;
        }

        & > div.plus {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }

    &__button {
      display: flex;
      height: 2.2em;
      justify-content: center;
      align-items: center;
      font-size: 0.875em;
      border-radius: 8px;
      border: solid 1.3px #cbee6b;
      color: $green;
      background-color: $blue;
      width: 100%;
      max-width: 15em;
      text-align: center;
      margin: 0.4em 0.3em;
      font-family: Avenir-Medium, sans-serif;
      cursor: pointer;

      & > .icn-goal {
        padding-top: 0.3em;
        margin-left: 1em;
      }

      & > .icn-relevant-plays {
        padding-top: 0.5em;
        margin-left: 0.9em;
      }

      &--active {
        padding-top: 0.2em;
        color: $blue;
        background-color: $green;
        font-family: Avenir-Bold, sans-serif;
      }
    }

    &.header--first-row {
      & .media-player__header__button {
        width: fit-content;
        padding: 0 2.5em;
      }
    }

    &.header--width-540 {
      .media-player__header {
        &__icon {
          display: none;
        }

        &__button {
          font-size: 0.9125em;
          max-width: 11em;
          padding: 0 0.5em;

          & > .icn-goal {
            height: auto;
            width: 1.5em;
          }

          & > .icn-relevant-plays {
            height: auto;
            width: 1.5em;
          }
        }

        &__modal-launcher {
          & > div.text {
            display: none;
          }

          & > div.plus {
            display: block;
          }
        }
      }
    }

    &.header--width-626 {
      .media-player__header {
        &__modal-launcher {
          & > div.text {
            display: none;
          }

          & > div.plus {
            display: block;
          }
        }
      }
    }

    &.header--width-400 {
      .media-player__header {
        &__icon {
          display: none;
        }

        &__button {
          font-size: 0.8125em;
          height: 2.4615em;
          width: fit-content;
          padding: 0.3em 1em 0;
          white-space: nowrap;

          & > .icn-goal {
            height: auto;
            width: 1.5em;
          }

          & > .icn-relevant-plays {
            height: auto;
            width: 1.5em;
          }

          &--active {
          }
        }

        &__modal-launcher {
          & > div.text {
            display: none;
          }

          & > div.plus {
            display: block;
          }
        }
      }
    }

    &.header--width-354 {
      justify-content: flex-end;
      .media-player__header {
        &__icon {
          display: none;
        }

        &__button {
          font-size: 0.8125em;
          height: 2.4615em;
          width: fit-content;
          padding: 0.3em 1em 0;
          white-space: nowrap;

          & > .icn-goal {
            height: auto;
            width: 1.5em;
          }

          & > .icn-relevant-plays {
            height: auto;
            width: 1.5em;
          }
        }

        &__modal-launcher {
          position: static;
          margin-right: 0.5em;

          & > div.text {
            display: none;
          }

          & > div.plus {
            display: block;
          }
        }
      }
    }
  }

  &__play-info {
    width: 100%;
    margin-top: 0.5em;

    &__entertainment {
      width: 100%;
      display: grid;
      grid-template-columns: 48px 1fr min-content 48px;
      font-size: 1.4375em;
      width: 100%;
      border-radius: 0.5em;
      border: solid 3px $green;
      padding: 0.5em;
      font-family: Roboto-Medium, sans-serif;

      & > div {
        justify-self: center;
        align-self: center;
      }

      & .player {
        margin: 0 0.4em;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
      }

      & .vs {
        margin: 0 0.4em;
      }

      & .team-logo {
        height: 48px;
        width: 48px;
        margin: 0 0.8em;

        & img {
          height: 48px;
          width: 48px;
        }
      }

      @media screen and (max-width: 400px) {
        padding: 0.5em 0;
        font-size: 1em;
      }
    }
  }

  &__mode {
    display: flex;
    width: 100%;
    justify-content: center;
    margin: 2rem 0 1rem;

    &__options {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      width: 90%;
      border-radius: 15px;
      box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.19);
      background-color: #f6f6f6;
      font-size: 1.6rem;
      font-family: Avenir-Medium, sans-serif;
      color: #3e3e3e;
      position: relative;

      &__background {
        position: absolute;
        width: 50%;
        height: 100%;
        left: 0;
        background-color: #3c3c3c;
        border-radius: 15px;
        z-index: 0;
        -webkit-transition: all 0.6s;
        transition: all 0.6s;
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.21);

        &.retro {
          left: 50%;
        }
      }

      & > div {
        padding: 1.3rem;
        border-radius: 15px;
        cursor: pointer;
        z-index: 1;
        -webkit-transition: all 0.6s;
        transition: all 0.6s;

        &.active {
          color: white;
        }
      }

      @media screen and (max-width: 620px) {
        width: 100%;
        font-size: 0.8rem;

        & > div {
          padding: 1.1rem 0;
          border-radius: 10px;
        }
      }
    }
  }

  &__categories {
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 420px) {
      justify-content: space-between;
    }

    & > div {
      width: 16.25rem;
      height: 4.6rem;
      margin: 1rem;
      border-radius: 10px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: Avenir-Pro-Bold, sans-serif;
      font-size: 1.25rem;
      border: solid 2px #d7dce2;
      color: #636462;

      &:first-child {
        @media screen and (max-width: 620px) {
          margin-right: 0.5rem;
        }
      }

      &:last-child {
        @media screen and (max-width: 620px) {
          margin-left: 0.5rem;
        }
      }

      @media screen and (max-width: 620px) {
        font-size: 0.8rem;
        height: 3rem;
        margin: 1rem 0;
      }
    }
  }

  &__image {
    position: relative;
    width: 100%;
    aspect-ratio: 9/5;
    background-image: url('https://golstatsimages.blob.core.windows.net/todoelfut/cortinilla_video.jpg');
    background-position: center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;

    &__text {
      color: white;
      font-family: Avenir-Medium, sans-serif;
      font-size: 2rem;

      & > span {
        font-family: Avenir-Pro-Bold, sans-serif;
      }

      @media screen and (max-width: 460px) {
        font-size: 1rem;
      }
    }
  }
}
.button--active {
  border: solid 2px #0c98fd !important;
  background-color: #0c98fd !important;
  color: white !important;
}
</style>
